export const ALL_COMPONENT_FAMILIES = [
  { name: 'DP', type: 'dp' },
  { name: 'HWDP', type: 'hwdp' },
  { name: 'Bit', type: 'bit' },
  { name: 'DC', type: 'dc' },
  { name: 'Jar', type: 'jar' },
  { name: 'PDM', type: 'pdm' },
  { name: 'MWD', type: 'mwd' },
  { name: 'LWD', type: 'lwd' },
  { name: 'Stabilizer', type: 'stabilizer' },
  { name: 'AGS', type: 'ags' },
  { name: 'Sub', type: 'sub' },
  { name: 'RSS', type: 'rss' },
  { name: 'Under Reamer', type: 'ur', segment: 'drilling' },
  { name: 'Agitator', type: 'agitator' },
  { name: 'CT', type: 'ct', segment: 'completion' },
];

export const COMPONENT_FAMILIES = {
  drilling: ALL_COMPONENT_FAMILIES.filter(({ segment = 'drilling' }) => segment === 'drilling'),
  completion: ALL_COMPONENT_FAMILIES.filter(
    ({ segment = 'completion' }) => segment === 'completion'
  ),
};

export const COMPONENT_GRADES = [
  { name: 'G105', type: 'G105' },
  { name: 'S135', type: 'S135' },
  { name: 'Z140', type: 'Z140' },
  { name: 'P110', type: 'P110' },
  { name: 'V150', type: 'V150' },
  { name: 'N80', type: 'N80' },
  { name: 'Q125', type: 'Q125' },
  { name: 'H40', type: 'H40' },
  { name: 'J55', type: 'J55' },
  { name: 'K55', type: 'K55' },
  { name: 'L80', type: 'L80' },
  { name: 'C90', type: 'C90' },
  { name: 'C95', type: 'C95' },
  { name: 'T95', type: 'T95' },
  { name: 'VM-105 DP LT', type: 'VM-105 DP LT' },
  { name: 'VM-105 DP MS', type: 'VM-105 DP MS' },
  { name: 'VM-105 DP S', type: 'VM-105 DP S' },
  { name: 'VM-105 DP SS', type: 'VM-105 DP SS' },
  { name: 'VM-105 DP SSE', type: 'VM-105 DP SSE' },
  { name: 'VM-120 DP MS', type: 'VM-120 DP MS' },
  { name: 'VM-135 DP LT', type: 'VM-135 DP LT' },
  { name: 'VM-140 DP', type: 'VM-140 DP' },
  { name: 'VM-150 DP', type: 'VM-150 DP' },
  { name: 'VM-165 DP', type: 'VM-165 DP' },
  { name: 'VM-95 DP LT', type: 'VM-95 DP LT' },
  { name: 'VM-95 DP S', type: 'VM-95 DP S' },
  { name: 'VM-95 DP SS', type: 'VM-95 DP SS' },
  { name: 'AISI 4145 H1', type: 'AISI 4145 H1' },
  { name: 'AISI 4145 H2', type: 'AISI 4145 H2' },
  { name: 'AISI 1340', type: 'AISI 1340' },
];

export const COMPONENT_CLASSES = [
  { name: 'New', type: 'New' },
  { name: 'Premium', type: 'Premium' },
  { name: 'Class 2', type: 'Class 2' },
  { name: '10% Wear', type: '10% Wear' },
];

export const COMPONENT_MATERIALS = [
  { name: 'Steel', type: 'Steel' },
  { name: 'Aluminium', type: 'Aluminium' },
  { name: 'Titanium', type: 'Titanium' },
  { name: 'Non Magnetic', type: 'Non Magnetic' },
];

export const COMPONENT_CATALOGUES = [
  { name: 'CATALOGUE1', type: 'catalogue1' },
  { name: 'CATALOGUE1', type: 'catalogue2' },
];

export const DC_SUB_CATEGORIES = [
  { name: 'Steel', type: 'Steel' },
  { name: 'NonMag', type: 'NonMag' },
];

export const JAR_SUB_CATEGORIES = [
  { name: 'Mechanical', type: 'Mechanical' },
  { name: 'Hydraulic', type: 'Hydraulic' },
];

export const BIT_TYPES = [
  { name: 'Tri Cone', type: 'Tri Cone' },
  { name: 'PDC', type: 'pdc' },
];

export const LWD_MEASUREMENT_TYPES = [
  { name: 'Gamma Ray', type: 'Gamma Ray' },
  { name: 'Caliper', type: 'Caliper' },
  { name: 'Resistivity', type: 'Resistivity' },
  { name: 'Density', type: 'Density' },
  { name: 'Porosity', type: 'Porosity' },
  { name: 'Acoustics Slowness', type: 'Acoustics Slowness' },
  { name: 'Annulus Temp', type: 'Annulus Temp' },
  { name: 'Annulus Pressure', type: 'Annulus Pressure' },
  { name: 'Formation Pressure/Sampling', type: 'Formation Pressure/Sampling' },
  { name: 'Photo Electric Factor', type: 'Photo Electric Factor' },
  { name: 'NMR', type: 'NMR' },
  { name: 'Borehole Image', type: 'Borehole Image' },
];

export const DP_DETAIL_VALUE_LIST = [
  {
    family: 'dp',
    outer_diameter: 4,
    inner_diameter: 3.24,
    outer_diameter_tooljoint: 5.25,
    inner_diameter_tooljoint: 2.563,
    length_tooljoint: 1.75,
    linear_weight: 17.55,
    grade: 'SS105',
    connection_type: '4" DS40 (Tourmaline)',
  },
  {
    family: 'dp',
    outer_diameter: 4.5,
    inner_diameter: 3.826,
    outer_diameter_tooljoint: 5.25,
    inner_diameter_tooljoint: 2.688,
    length_tooljoint: 1.75,
    linear_weight: 18.13,
    grade: 'S135',
    connection_type: '4.5" DS40 (Tourmaline)',
  },
  {
    family: 'dp',
    outer_diameter: 4.5,
    inner_diameter: 3.826,
    outer_diameter_tooljoint: 5.25,
    inner_diameter_tooljoint: 2.688,
    length_tooljoint: 2.083,
    linear_weight: 18.34,
    grade: 'SS105',
    connection_type: '4.5" XT40 (Tourmaline)',
  },
  {
    family: 'dp',
    outer_diameter: 4.5,
    inner_diameter: 3.826,
    outer_diameter_tooljoint: 5.25,
    inner_diameter_tooljoint: 3,
    length_tooljoint: 2.33,
    linear_weight: 16.6,
    grade: 'S135',
    connection_type: '4.5" PTECH-43 (ARC)',
  },
  {
    family: 'dp',
    outer_diameter: 5.5,
    inner_diameter: 4.778,
    outer_diameter_tooljoint: 6.625,
    inner_diameter_tooljoint: 4,
    length_tooljoint: 3.875,
    linear_weight: 24.11,
    grade: 'S135',
    connection_type: '5.5" CET54 (Ascent)',
  },
  {
    family: 'dp',
    outer_diameter: 4.5,
    inner_diameter: 3.826,
    outer_diameter_tooljoint: 5.375,
    inner_diameter_tooljoint: 3.826,
    length_tooljoint: 2.42,
    linear_weight: 18.7,
    grade: '',
    connection_type: '4.5 DS42 (Shell)',
  },
  {
    family: 'dp',
    outer_diameter: 4.5,
    inner_diameter: 3.826,
    outer_diameter_tooljoint: 5.5,
    inner_diameter_tooljoint: 3,
    length_tooljoint: 2.33,
    linear_weight: 17.71,
    grade: '',
    connection_type: '4.5 450DUO (Shell)',
  },
  {
    family: 'dp',
    outer_diameter: 4.75,
    inner_diameter: 4.076,
    outer_diameter_tooljoint: 5.625,
    inner_diameter_tooljoint: 3.75,
    length_tooljoint: 2.33,
    linear_weight: 17.77,
    grade: '',
    connection_type: '4.75 480DUO (Shell)',
  },
  {
    family: 'dp',
    outer_diameter: 5.5,
    inner_diameter: 4.778,
    outer_diameter_tooljoint: 7,
    inner_diameter_tooljoint: 4,
    length_tooljoint: 2.33,
    linear_weight: 24.24,
    grade: '',
    connection_type: '5.5 5.5FH (Shell)',
  },
  {
    family: 'dp',
    outer_diameter: 5.5,
    inner_diameter: 4.778,
    outer_diameter_tooljoint: 6.625,
    inner_diameter_tooljoint: 4,
    length_tooljoint: 2.25,
    linear_weight: 25.71,
    grade: 'S135',
    connection_type: '5.5 Delta544 (Birch)',
  },
  {
    family: 'dp',
    outer_diameter: 5.25,
    inner_diameter: 4.528,
    outer_diameter_tooljoint: 6.25,
    inner_diameter_tooljoint: 3.5,
    length_tooljoint: 2.42,
    linear_weight: 23.74,
    grade: 'S135',
    connection_type: '5.25 everdrl49 (Birch)',
  },
  {
    family: 'dp',
    outer_diameter: 5,
    inner_diameter: 4.126,
    outer_diameter_tooljoint: 5.875,
    inner_diameter_tooljoint: 3.25,
    length_tooljoint: 1.33,
    linear_weight: 22.22,
    grade: 'S135',
    connection_type: '5" evrdrl46G (Diamondback)',
  },
  {
    family: 'dp',
    outer_diameter: 5,
    inner_diameter: 4.276,
    outer_diameter_tooljoint: 6.625,
    inner_diameter_tooljoint: 3.25,
    length_tooljoint: 1,
    linear_weight: 23.82,
    grade: 'S135',
    connection_type: '5" NC50SST (Noble)',
  },
  {
    family: 'dp',
    outer_diameter: 4,
    inner_diameter: 3.34,
    outer_diameter_tooljoint: 4.875,
    inner_diameter_tooljoint: 2.813,
    length_tooljoint: 2.688,
    linear_weight: 16.27,
    grade: 'S135',
    connection_type: '4" XT39 (Vine & WPX)',
  },
  {
    family: 'dp',
    outer_diameter: 4.5,
    inner_diameter: 3.826,
    outer_diameter_tooljoint: 5.25,
    inner_diameter_tooljoint: 3,
    length_tooljoint: 2.875,
    linear_weight: 18.95,
    grade: 'S135',
    connection_type: '4.5" Delta 425 (Vine)',
  },
  {
    family: 'dp',
    outer_diameter: 5,
    inner_diameter: 4.778,
    outer_diameter_tooljoint: 6.625,
    inner_diameter_tooljoint: 4,
    length_tooljoint: 3.875,
    linear_weight: 25.84,
    grade: 'S135',
    connection_type: '5" Delta 544 (Vine)',
  },
  {
    family: 'dp',
    outer_diameter: 6.562,
    inner_diameter: 5.375,
    outer_diameter_tooljoint: 8.5,
    inner_diameter_tooljoint: 4.25,
    length_tooljoint: 2.67,
    linear_weight: 48.93,
    grade: 'S135',
    connection_type: '6.625 (NTM Exxon Guy)',
  },
  {
    family: 'dp',
    outer_diameter: 6.416,
    inner_diameter: 5.581,
    outer_diameter_tooljoint: 8.5,
    inner_diameter_tooljoint: 4.25,
    length_tooljoint: 2.67,
    linear_weight: 43.21,
    grade: 'S135',
    connection_type: '6.625 (NTM Exxon Guy)',
  },
  {
    family: 'dp',
    outer_diameter: 6.48,
    inner_diameter: 5.581,
    outer_diameter_tooljoint: 8.5,
    inner_diameter_tooljoint: 4.25,
    length_tooljoint: 2.67,
    linear_weight: 33.66,
    grade: 'S135',
    connection_type: '6.625 (NTM Exxon Guy)',
  },
  {
    family: 'dp',
    outer_diameter: 5.709,
    inner_diameter: 5.045,
    outer_diameter_tooljoint: 7,
    inner_diameter_tooljoint: 4.25,
    length_tooljoint: 2.67,
    linear_weight: 26.3,
    grade: 'S135',
    connection_type: '5.875 (NTM Exxon Guy)',
  },
  {
    family: 'dp',
    outer_diameter: 5.731,
    inner_diameter: 5.153,
    outer_diameter_tooljoint: 7,
    inner_diameter_tooljoint: 4.25,
    length_tooljoint: 2.67,
    linear_weight: 26.58,
    grade: 'S135',
    connection_type: '5.875 (NTM Exxon Guy)',
  },
  {
    family: 'dp',
    outer_diameter: 6.375,
    inner_diameter: 5.375,
    outer_diameter_tooljoint: 8.5,
    inner_diameter_tooljoint: 4.25,
    length_tooljoint: 2.67,
    linear_weight: 46.61,
    grade: 'S135',
    connection_type: '6.625 (NDT Exxon Guy)',
  },
  {
    family: 'dp',
    outer_diameter: 6.416,
    inner_diameter: 5.581,
    outer_diameter_tooljoint: 8.5,
    inner_diameter_tooljoint: 4.25,
    length_tooljoint: 2.67,
    linear_weight: 41.12,
    grade: 'S135',
    connection_type: '6.625 (NDT Exxon Guy)',
  },
  {
    family: 'dp',
    outer_diameter: 6.48,
    inner_diameter: 5.901,
    outer_diameter_tooljoint: 8.5,
    inner_diameter_tooljoint: 4.25,
    length_tooljoint: 2.67,
    linear_weight: 32.08,
    grade: 'S135',
    connection_type: '6.625 (NDT Exxon Guy)',
  },
  {
    family: 'dp',
    outer_diameter: 5.709,
    inner_diameter: 5.045,
    outer_diameter_tooljoint: 7,
    inner_diameter_tooljoint: 4.25,
    length_tooljoint: 2.41,
    linear_weight: 28.08,
    grade: 'S135',
    connection_type: '5.825 (NDT Exxon Guy)',
  },
  {
    family: 'dp',
    outer_diameter: 4.365,
    inner_diameter: 3.826,
    outer_diameter_tooljoint: 6,
    inner_diameter_tooljoint: 3.563,
    length_tooljoint: 2.42,
    linear_weight: 16.6,
    grade: 'S135',
    connection_type: '4.5 (NDT Exxon Guy)',
  },
  {
    family: 'dp',
    outer_diameter: 5,
    inner_diameter: 4.276,
    outer_diameter_tooljoint: 6.625,
    inner_diameter_tooljoint: 3.25,
    length_tooljoint: 3.125,
    linear_weight: 22.63,
    grade: 'G-105',
    connection_type: '5" NC50 (XTO CA)',
  },
  {
    family: 'dp',
    outer_diameter: 4,
    inner_diameter: 3.34,
    outer_diameter_tooljoint: 4.875,
    inner_diameter_tooljoint: 2.688,
    length_tooljoint: 2.563,
    linear_weight: 16.34,
    grade: 'S135',
    connection_type: '4" XT39 (XTO ETX)',
  },
  {
    family: 'dp',
    outer_diameter: 5.5,
    inner_diameter: 4.778,
    outer_diameter_tooljoint: 6.625,
    inner_diameter_tooljoint: 4,
    length_tooljoint: 3.875,
    linear_weight: 24.25,
    grade: 'S135',
    connection_type: '5.5" CET (XTO OK)',
  },
  {
    family: 'dp',
    outer_diameter: 5.5,
    inner_diameter: 4.778,
    outer_diameter_tooljoint: 7.5,
    inner_diameter_tooljoint: 3,
    length_tooljoint: 2.875,
    linear_weight: 26.33,
    grade: 'S135',
    connection_type: '5.5" FH (XTO Perm)',
  },
  {
    family: 'dp',
    outer_diameter: 4.5,
    inner_diameter: 3.793,
    outer_diameter_tooljoint: 5.375,
    inner_diameter_tooljoint: 3.25,
    length_tooljoint: 3.125,
    linear_weight: 16.55,
    grade: 'A135',
    connection_type: '4.5" evrdrl44 (Rockcliff)',
  },
  {
    family: 'dp',
    outer_diameter: 5.5,
    inner_diameter: 4.778,
    outer_diameter_tooljoint: 6.625,
    inner_diameter_tooljoint: 4,
    length_tooljoint: 3.875,
    linear_weight: 25.84,
    grade: 'S135',
    connection_type: '5.5" Delta544 (SWN)',
  },
  {
    family: 'dp',
    outer_diameter: 4.5,
    inner_diameter: 3.826,
    outer_diameter_tooljoint: 5.375,
    inner_diameter_tooljoint: 3.25,
    length_tooljoint: 3.125,
    linear_weight: 17.21,
    grade: 'S135',
    connection_type: '4.5" CET43 (Petronas)',
  },
  {
    family: 'dp',
    outer_diameter: 4,
    inner_diameter: 3.34,
    outer_diameter_tooljoint: 5.53,
    inner_diameter_tooljoint: 2.56,
    length_tooljoint: 2.3,
    linear_weight: 16.71,
    grade: 'S135',
    connection_type: '4" FH',
  },
  {
    family: 'dp',
    outer_diameter: 4,
    inner_diameter: 3.34,
    outer_diameter_tooljoint: 5,
    inner_diameter_tooljoint: 2.67,
    length_tooljoint: 2,
    linear_weight: 16.35,
    grade: 'S135',
    connection_type: '4" HT-40',
  },
  {
    family: 'dp',
    outer_diameter: 4.5,
    inner_diameter: 3.83,
    outer_diameter_tooljoint: 5.25,
    inner_diameter_tooljoint: 2.69,
    length_tooljoint: 2.4,
    linear_weight: 19.64,
    grade: 'S135',
    connection_type: '4.5" GPDS-40',
  },
  {
    family: 'dp',
    outer_diameter: 4.5,
    inner_diameter: 3.83,
    outer_diameter_tooljoint: 5.25,
    inner_diameter_tooljoint: 2.81,
    length_tooljoint: 2.2,
    linear_weight: 19.08,
    grade: 'S135',
    connection_type: '4.5" GPDS-42',
  },
  {
    family: 'dp',
    outer_diameter: 5,
    inner_diameter: 4.28,
    outer_diameter_tooljoint: 6.63,
    inner_diameter_tooljoint: 3.25,
    length_tooljoint: 1.75,
    linear_weight: 24.11,
    grade: 'S135',
    connection_type: '5" 4.5" IF',
  },
  {
    family: 'dp',
    outer_diameter: 5,
    inner_diameter: 4.28,
    outer_diameter_tooljoint: 6.63,
    inner_diameter_tooljoint: 2.75,
    length_tooljoint: 1.75,
    linear_weight: 22.39,
    grade: 'S135',
    connection_type: '5" 4.5" IF',
  },
];

export const HWDP_DETAIL_VALUE_LIST = [
  {
    family: 'hwdp',
    outer_diameter: 4,
    inner_diameter: 2.56,
    outer_diameter_tooljoint: 5.25,
    inner_diameter_tooljoint: 2.56,
    length_tooljoint: 4,
    linear_weight: 30.165,
    grade: 'SS105',
    connection_type: '4" DS40 (Tourmaline)',
  },
  {
    family: 'hwdp',
    outer_diameter: 4.5,
    inner_diameter: 2.75,
    outer_diameter_tooljoint: 5.25,
    inner_diameter_tooljoint: 2.75,
    length_tooljoint: 4.5,
    linear_weight: 38.03,
    grade: 'S135',
    connection_type: '4.5" DS40 (Tourmaline)',
  },
  {
    family: 'hwdp',
    outer_diameter: 4.5,
    inner_diameter: 2.75,
    outer_diameter_tooljoint: 5.25,
    inner_diameter_tooljoint: 2.75,
    length_tooljoint: 4.5,
    linear_weight: 37.01,
    grade: 'SS105',
    connection_type: '4.5" XT40 (Tourmaline)',
  },
  {
    family: 'hwdp',
    outer_diameter: 4.5,
    inner_diameter: 2.75,
    outer_diameter_tooljoint: 5.3125,
    inner_diameter_tooljoint: 2.875,
    length_tooljoint: 4.75,
    linear_weight: 37.37,
    grade: 'S135',
    connection_type: '4.5" PTECH-43 (ARC)',
  },
  {
    family: 'hwdp',
    outer_diameter: 4.5,
    inner_diameter: 2.688,
    outer_diameter_tooljoint: 5.25,
    inner_diameter_tooljoint: 2.688,
    length_tooljoint: 4,
    linear_weight: 38,
    grade: '',
    connection_type: '4.5 DS42 (Shell)',
  },
  {
    family: 'hwdp',
    outer_diameter: 4.5,
    inner_diameter: 2.813,
    outer_diameter_tooljoint: 5.5,
    inner_diameter_tooljoint: 2.813,
    length_tooljoint: 4.33,
    linear_weight: 36.34,
    grade: '',
    connection_type: '4.5 450DUO (Shell)',
  },
  {
    family: 'hwdp',
    outer_diameter: 5.5,
    inner_diameter: 3.25,
    outer_diameter_tooljoint: 7.25,
    inner_diameter_tooljoint: 3.25,
    length_tooljoint: 4.5,
    linear_weight: 62.73,
    grade: '',
    connection_type: '5.5FH (Shell)',
  },
  {
    family: 'hwdp',
    outer_diameter: 5.5,
    inner_diameter: 3.25,
    outer_diameter_tooljoint: 6.625,
    inner_diameter_tooljoint: 3.25,
    length_tooljoint: 5,
    linear_weight: 58.41,
    grade: 'Welded 55 KSI',
    connection_type: '5.5 Delta544 (Birch)',
  },
  {
    family: 'hwdp',
    outer_diameter: 6.625,
    inner_diameter: 4.5,
    outer_diameter_tooljoint: 8.5,
    inner_diameter_tooljoint: 4.5,
    length_tooljoint: 4,
    linear_weight: 77.78,
    grade: 'HW-105',
    connection_type: '6.625FH (NTM Exxon Guy)',
  },
  {
    family: 'hwdp',
    outer_diameter: 5.875,
    inner_diameter: 4,
    outer_diameter_tooljoint: 7,
    inner_diameter_tooljoint: 4.25,
    length_tooljoint: 4,
    linear_weight: 57.25,
    grade: 'HW-105',
    connection_type: '5.875XT57 (NTM Exxon Guy)',
  },
  {
    family: 'hwdp',
    outer_diameter: 6.625,
    inner_diameter: 4.5,
    outer_diameter_tooljoint: 8.5,
    inner_diameter_tooljoint: 4.5,
    length_tooljoint: 4,
    linear_weight: 72.54,
    grade: 'HW-105',
    connection_type: '6.625FH (NDT Exxon Guy)',
  },
  {
    family: 'hwdp',
    outer_diameter: 5.5,
    inner_diameter: 3.25,
    outer_diameter_tooljoint: 6.625,
    inner_diameter_tooljoint: 3.25,
    length_tooljoint: 3,
    linear_weight: 57.92,
    grade: '',
    connection_type: '5.5" Delta 544 (Vine)',
  },
  {
    family: 'hwdp',
    outer_diameter: 4,
    inner_diameter: 2.563,
    outer_diameter_tooljoint: 4.875,
    inner_diameter_tooljoint: 2.563,
    length_tooljoint: 2.313,
    linear_weight: 28.38,
    grade: '',
    connection_type: '4" XT39 (WPX)',
  },
  {
    family: 'hwdp',
    outer_diameter: 5,
    inner_diameter: 3,
    outer_diameter_tooljoint: 6.625,
    inner_diameter_tooljoint: 3,
    length_tooljoint: 2.875,
    linear_weight: 50.94,
    grade: 'Welded 55 KSI',
    connection_type: '5" NC50 (XTO CA)',
  },
  {
    family: 'hwdp',
    outer_diameter: 4,
    inner_diameter: 2.562,
    outer_diameter_tooljoint: 4.875,
    inner_diameter_tooljoint: 2.563,
    length_tooljoint: 2.313,
    linear_weight: 28.4,
    grade: '',
    connection_type: '4" XT39(XTO ETX)',
  },
  {
    family: 'hwdp',
    outer_diameter: 5,
    inner_diameter: 3,
    outer_diameter_tooljoint: 6.625,
    inner_diameter_tooljoint: 3,
    length_tooljoint: 2.75,
    linear_weight: 59.16,
    grade: 'S134',
    connection_type: '5" Spiral NC50 (XTO Perm)',
  },
  {
    family: 'hwdp',
    outer_diameter: 4.5,
    inner_diameter: 3,
    outer_diameter_tooljoint: 5.375,
    inner_diameter_tooljoint: 3,
    length_tooljoint: 2.875,
    linear_weight: 34.22,
    grade: 'Welded 55ksi',
    connection_type: '4.5" Welded 55ksi (Petronas)',
  },
  {
    family: 'hwdp',
    outer_diameter: 4.5,
    inner_diameter: 2.75,
    outer_diameter_tooljoint: 5.25,
    inner_diameter_tooljoint: 2.75,
    length_tooljoint: 4.5,
    linear_weight: 38.03,
    grade: 'S135',
    connection_type: '4.5" GPDS-40',
  },
  {
    family: 'hwdp',
    outer_diameter: 4.5,
    inner_diameter: 2.75,
    outer_diameter_tooljoint: 5.25,
    inner_diameter_tooljoint: 2.75,
    length_tooljoint: 4.5,
    linear_weight: 37.75,
    grade: 'S135',
    connection_type: '4.5" GPDS-42',
  },
  {
    family: 'hwdp',
    outer_diameter: 4.5,
    inner_diameter: 2.81,
    outer_diameter_tooljoint: 5.38,
    inner_diameter_tooljoint: 3,
    length_tooljoint: 4.5,
    linear_weight: 37.13,
    grade: 'S135',
    connection_type: '4.5" CET-42',
  },
  {
    family: 'hwdp',
    outer_diameter: 5,
    inner_diameter: 3,
    outer_diameter_tooljoint: 6.63,
    inner_diameter_tooljoint: 3.06,
    length_tooljoint: 4,
    linear_weight: 49.77,
    grade: 'S135',
    connection_type: '5" 4.5"IF',
  },
  {
    family: 'hwdp',
    outer_diameter: 5,
    inner_diameter: 3,
    outer_diameter_tooljoint: 6.63,
    inner_diameter_tooljoint: 3,
    length_tooljoint: 4,
    linear_weight: 59.73,
    grade: 'S135',
    connection_type: '5" 4.5"IF (Spiral)',
  },
];

export const PDM_DETAIL_VALUE_LIST = [
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X/LS',
    outer_diameter: 2.75,
    stages: 2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 2.75,
    min_standard_flowrate: 25,
    max_standard_flowrate: 80,
    torque_at_max_operating_differential_pressure: 320,
    max_operating_differential_pressure: 465,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X/LS-HP',
    outer_diameter: 2.75,
    stages: 2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 2.75,
    min_standard_flowrate: 25,
    max_standard_flowrate: 80,
    torque_at_max_operating_differential_pressure: 400,
    max_operating_differential_pressure: 580,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme',
    outer_diameter: 2.75,
    stages: 2.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 5.44,
    min_standard_flowrate: 25,
    max_standard_flowrate: 80,
    torque_at_max_operating_differential_pressure: 365,
    max_operating_differential_pressure: 905,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X/LS',
    outer_diameter: 2.875,
    stages: 2.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.88,
    min_standard_flowrate: 25,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 590,
    max_operating_differential_pressure: 580,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X/LS-HP',
    outer_diameter: 2.875,
    stages: 2.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.88,
    min_standard_flowrate: 25,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 740,
    max_operating_differential_pressure: 725,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X',
    outer_diameter: 2.875,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 4.08,
    min_standard_flowrate: 25,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 435,
    max_operating_differential_pressure: 930,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X-HP',
    outer_diameter: 2.875,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 4.08,
    min_standard_flowrate: 25,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 545,
    max_operating_differential_pressure: 1150,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X-HS',
    outer_diameter: 2.875,
    stages: 5.3,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 7.69,
    min_standard_flowrate: 25,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 340,
    max_operating_differential_pressure: 1250,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X/HS-HP',
    outer_diameter: 2.875,
    stages: 5.3,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 7.69,
    min_standard_flowrate: 25,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 420,
    max_operating_differential_pressure: 1550,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra HS',
    outer_diameter: 2.875,
    stages: 9,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 7.69,
    min_standard_flowrate: 25,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 570,
    max_operating_differential_pressure: 2100,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XS-HP',
    outer_diameter: 2.875,
    stages: 9,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 7.69,
    min_standard_flowrate: 25,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 710,
    max_operating_differential_pressure: 2600,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme',
    outer_diameter: 2.875,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 4.08,
    min_standard_flowrate: 25,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 780,
    max_operating_differential_pressure: 1450,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra AD',
    outer_diameter: 3.125,
    stages: 2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.78,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 1150,
    max_operating_differential_pressure: 465,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X',
    outer_diameter: 3.125,
    stages: 3.2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 2.28,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 585,
    max_operating_differential_pressure: 695,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL',
    outer_diameter: 3.125,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 2.28,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 1150,
    max_operating_differential_pressure: 1400,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/LS',
    outer_diameter: 3.5,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.08,
    min_standard_flowrate: 80,
    max_standard_flowrate: 180,
    torque_at_max_operating_differential_pressure: 1650,
    max_operating_differential_pressure: 930,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra HS',
    outer_diameter: 3.5,
    stages: 7,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 6.67,
    min_standard_flowrate: 80,
    max_standard_flowrate: 180,
    torque_at_max_operating_differential_pressure: 575,
    max_operating_differential_pressure: 1600,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X-treme IR',
    outer_diameter: 3.5,
    stages: 1.2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.08,
    min_standard_flowrate: 80,
    max_standard_flowrate: 180,
    torque_at_max_operating_differential_pressure: 550,
    max_operating_differential_pressure: 270,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme LS',
    outer_diameter: 3.5,
    stages: 2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.08,
    min_standard_flowrate: 80,
    max_standard_flowrate: 180,
    torque_at_max_operating_differential_pressure: 1450,
    max_operating_differential_pressure: 725,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme',
    outer_diameter: 3.5,
    stages: 7,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.94,
    min_standard_flowrate: 80,
    max_standard_flowrate: 180,
    torque_at_max_operating_differential_pressure: 2300,
    max_operating_differential_pressure: 2000,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme HS',
    outer_diameter: 3.5,
    stages: 7,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 6.67,
    min_standard_flowrate: 80,
    max_standard_flowrate: 180,
    torque_at_max_operating_differential_pressure: 805,
    max_operating_differential_pressure: 2000,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL',
    outer_diameter: 3.75,
    stages: 11.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.95,
    min_standard_flowrate: 80,
    max_standard_flowrate: 210,
    torque_at_max_operating_differential_pressure: 2550,
    max_operating_differential_pressure: 2550,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X',
    outer_diameter: 4.75,
    stages: 5.2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.03,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 2200,
    max_operating_differential_pressure: 1150,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/VS',
    outer_diameter: 4.75,
    stages: 2.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.27,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 4250,
    max_operating_differential_pressure: 580,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/VS-HP',
    outer_diameter: 4.75,
    stages: 2.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.27,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 5300,
    max_operating_differential_pressure: 725,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/LS',
    outer_diameter: 4.75,
    stages: 4.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.49,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 4150,
    max_operating_differential_pressure: 1050,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/LS-HP',
    outer_diameter: 4.75,
    stages: 4.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.49,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 5200,
    max_operating_differential_pressure: 1300,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL',
    outer_diameter: 4.75,
    stages: 9.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.03,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 4150,
    max_operating_differential_pressure: 2200,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL-HP',
    outer_diameter: 4.75,
    stages: 9.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.03,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 5200,
    max_operating_differential_pressure: 2750,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/RF',
    outer_diameter: 4.75,
    stages: 12.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.49,
    min_standard_flowrate: 90,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 3900,
    max_operating_differential_pressure: 2900,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/RF-HP',
    outer_diameter: 4.75,
    stages: 12.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.49,
    min_standard_flowrate: 90,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 4850,
    max_operating_differential_pressure: 3600,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra HS',
    outer_diameter: 4.75,
    stages: 11,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 2.32,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 2350,
    max_operating_differential_pressure: 2550,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra HS-HP',
    outer_diameter: 4.75,
    stages: 11,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 2.32,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 2950,
    max_operating_differential_pressure: 3200,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra TS',
    outer_diameter: 4.75,
    stages: 10.5,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 3.97,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 1450,
    max_operating_differential_pressure: 2450,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra TS-HP',
    outer_diameter: 4.75,
    stages: 10.5,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 3.97,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 1800,
    max_operating_differential_pressure: 3050,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X-treme LS',
    outer_diameter: 4.75,
    stages: 2.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.49,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 4100,
    max_operating_differential_pressure: 905,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X-treme',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.03,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 3900,
    max_operating_differential_pressure: 1800,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X-treme IR',
    outer_diameter: 4.75,
    stages: 1.6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.03,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 980,
    max_operating_differential_pressure: 455,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X-treme LS',
    outer_diameter: 4.75,
    stages: 4.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.49,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 5900,
    max_operating_differential_pressure: 1300,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme',
    outer_diameter: 4.75,
    stages: 9.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.03,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 5950,
    max_operating_differential_pressure: 2750,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme HS',
    outer_diameter: 4.75,
    stages: 9.5,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 3.65,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 2000,
    max_operating_differential_pressure: 2750,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme eXtend RS',
    outer_diameter: 5,
    stages: 9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.76,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 7100,
    max_operating_differential_pressure: 2600,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme eXtend MS',
    outer_diameter: 5,
    stages: 12.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.03,
    min_standard_flowrate: 105,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 7100,
    max_operating_differential_pressure: 3550,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X',
    outer_diameter: 6.5,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.33,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 4050,
    max_operating_differential_pressure: 695,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X-HP',
    outer_diameter: 6.5,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.33,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 5050,
    max_operating_differential_pressure: 870,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/VS',
    outer_diameter: 6.5,
    stages: 2.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.11,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 9000,
    max_operating_differential_pressure: 580,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/VS-HP',
    outer_diameter: 6.5,
    stages: 2.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.11,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 11000,
    max_operating_differential_pressure: 725,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/LS',
    outer_diameter: 6.5,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.16,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 8500,
    max_operating_differential_pressure: 695,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/LS-HP',
    outer_diameter: 6.5,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.16,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 10500,
    max_operating_differential_pressure: 870,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL-RS',
    outer_diameter: 6.5,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.21,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 8450,
    max_operating_differential_pressure: 930,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/RS-HP',
    outer_diameter: 6.5,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.21,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 10500,
    max_operating_differential_pressure: 1150,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL-MS',
    outer_diameter: 6.5,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.27,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 9500,
    max_operating_differential_pressure: 1400,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/MS-HP',
    outer_diameter: 6.5,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.27,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 1150,
    max_operating_differential_pressure: 1750,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL',
    outer_diameter: 6.5,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.33,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 8100,
    max_operating_differential_pressure: 1400,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL-HP',
    outer_diameter: 6.5,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.33,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 10000,
    max_operating_differential_pressure: 1750,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/RF',
    outer_diameter: 6.5,
    stages: 8.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.53,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 7450,
    max_operating_differential_pressure: 1950,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/RF-HP',
    outer_diameter: 6.5,
    stages: 8.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.53,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 9300,
    max_operating_differential_pressure: 2450,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra HS',
    outer_diameter: 6.5,
    stages: 8,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 0.89,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 4450,
    max_operating_differential_pressure: 1850,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X-treme LS',
    outer_diameter: 6.5,
    stages: 2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.2,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 7800,
    max_operating_differential_pressure: 725,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X-treme',
    outer_diameter: 6.5,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.33,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 7250,
    max_operating_differential_pressure: 1100,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.33,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 4050,
    max_operating_differential_pressure: 695,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X-HP',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.33,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 5050,
    max_operating_differential_pressure: 870,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/VS',
    outer_diameter: 6.75,
    stages: 2.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.11,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 9000,
    max_operating_differential_pressure: 580,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/VS-HP',
    outer_diameter: 6.75,
    stages: 2.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.11,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 11000,
    max_operating_differential_pressure: 725,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/LS',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.16,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 8500,
    max_operating_differential_pressure: 695,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/LS-HP',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.16,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 10500,
    max_operating_differential_pressure: 870,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL-RS',
    outer_diameter: 6.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.21,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 8450,
    max_operating_differential_pressure: 930,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/RS-HP',
    outer_diameter: 6.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.21,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 10500,
    max_operating_differential_pressure: 1150,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL-MS',
    outer_diameter: 6.75,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.27,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 9500,
    max_operating_differential_pressure: 1400,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/MS-HP',
    outer_diameter: 6.75,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.27,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 11500,
    max_operating_differential_pressure: 1750,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL',
    outer_diameter: 6.75,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.33,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 8100,
    max_operating_differential_pressure: 1400,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL-HP',
    outer_diameter: 6.75,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.33,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 10000,
    max_operating_differential_pressure: 1750,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/RF',
    outer_diameter: 6.75,
    stages: 8.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.53,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 7450,
    max_operating_differential_pressure: 1950,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/RF-HP',
    outer_diameter: 6.75,
    stages: 8.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.53,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 9300,
    max_operating_differential_pressure: 2450,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra HS',
    outer_diameter: 6.75,
    stages: 8,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 0.89,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 4450,
    max_operating_differential_pressure: 1850,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X-treme LS',
    outer_diameter: 6.75,
    stages: 2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.2,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 7800,
    max_operating_differential_pressure: 725,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X-treme',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.33,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 7250,
    max_operating_differential_pressure: 1100,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme LS',
    outer_diameter: 6.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.2,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 12500,
    max_operating_differential_pressure: 1150,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme',
    outer_diameter: 6.75,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.33,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 11500,
    max_operating_differential_pressure: 1750,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme HS',
    outer_diameter: 6.75,
    stages: 9,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 1.67,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 4050,
    max_operating_differential_pressure: 2600,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL45/RS-HP',
    outer_diameter: 7,
    stages: 6.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.2,
    min_standard_flowrate: 265,
    max_standard_flowrate: 660,
    torque_at_max_operating_differential_pressure: 16500,
    max_operating_differential_pressure: 1850,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/VS',
    outer_diameter: 8,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.09,
    min_standard_flowrate: 395,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 13000,
    max_operating_differential_pressure: 695,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/VS-HP',
    outer_diameter: 8,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.09,
    min_standard_flowrate: 395,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 16500,
    max_operating_differential_pressure: 870,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/LS',
    outer_diameter: 8,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.15,
    min_standard_flowrate: 395,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 13500,
    max_operating_differential_pressure: 1150,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/LS-HP',
    outer_diameter: 8,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.15,
    min_standard_flowrate: 395,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 17000,
    max_operating_differential_pressure: 1450,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL',
    outer_diameter: 8,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.22,
    min_standard_flowrate: 395,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 12500,
    max_operating_differential_pressure: 1400,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL-HP',
    outer_diameter: 8,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.22,
    min_standard_flowrate: 395,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 15500,
    max_operating_differential_pressure: 1750,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.22,
    min_standard_flowrate: 395,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 14660,
    max_operating_differential_pressure: 1450,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/VS',
    outer_diameter: 9.5,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.09,
    min_standard_flowrate: 530,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 19000,
    max_operating_differential_pressure: 930,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL/VS-HP',
    outer_diameter: 9.5,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.09,
    min_standard_flowrate: 530,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 24000,
    max_operating_differential_pressure: 1150,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL',
    outer_diameter: 9.5,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.15,
    min_standard_flowrate: 530,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 17500,
    max_operating_differential_pressure: 1400,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra XL-HP',
    outer_diameter: 9.5,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.15,
    min_standard_flowrate: 530,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 21500,
    max_operating_differential_pressure: 1750,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme LS',
    outer_diameter: 9.5,
    stages: 2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.08,
    min_standard_flowrate: 530,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 20500,
    max_operating_differential_pressure: 725,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme',
    outer_diameter: 9.5,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.15,
    min_standard_flowrate: 530,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 20500,
    max_operating_differential_pressure: 1450,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme HS',
    outer_diameter: 9.5,
    stages: 9.5,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 0.93,
    min_standard_flowrate: 395,
    max_standard_flowrate: 1050,
    torque_at_max_operating_differential_pressure: 7800,
    max_operating_differential_pressure: 2750,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme XL/LS',
    outer_diameter: 9.5,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.08,
    min_standard_flowrate: 530,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 24500,
    max_operating_differential_pressure: 870,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme XL/RS',
    outer_diameter: 9.5,
    stages: 5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.13,
    min_standard_flowrate: 530,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 24500,
    max_operating_differential_pressure: 1450,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X',
    outer_diameter: 11.25,
    stages: 4,
    number_rotor_lobes: 9,
    number_stator_lobes: 10,
    rpg: 0.08,
    min_standard_flowrate: 635,
    max_standard_flowrate: 1500,
    torque_at_max_operating_differential_pressure: 28500,
    max_operating_differential_pressure: 1150,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme XL/RF',
    outer_diameter: 11.75,
    stages: 7,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.13,
    min_standard_flowrate: 635,
    max_standard_flowrate: 1500,
    torque_at_max_operating_differential_pressure: 28000,
    max_operating_differential_pressure: 1600,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'Ultra X',
    outer_diameter: 12.75,
    stages: 4,
    number_rotor_lobes: 9,
    number_stator_lobes: 10,
    rpg: 0.08,
    min_standard_flowrate: 635,
    max_standard_flowrate: 1500,
    torque_at_max_operating_differential_pressure: 28500,
    max_operating_differential_pressure: 1150,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme',
    outer_diameter: 12.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.09,
    min_standard_flowrate: 790,
    max_standard_flowrate: 1750,
    torque_at_max_operating_differential_pressure: 37000,
    max_operating_differential_pressure: 1450,
  },
  {
    family: 'pdm',
    make: 'Baker Hughes',
    model: 'X-treme XL/RF',
    outer_diameter: 12.75,
    stages: 7,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.13,
    min_standard_flowrate: 635,
    max_standard_flowrate: 1500,
    torque_at_max_operating_differential_pressure: 28000,
    max_operating_differential_pressure: 1600,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS150',
    outer_diameter: 2.875,
    stages: 3.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 3.87,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 806,
    max_operating_differential_pressure: 1300,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS100',
    outer_diameter: 3.125,
    stages: 2.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.34,
    min_standard_flowrate: 110,
    max_standard_flowrate: 210,
    torque_at_max_operating_differential_pressure: 1940,
    max_operating_differential_pressure: 1000,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS100',
    outer_diameter: 3.5,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.5,
    rpg: 1.34,
    min_standard_flowrate: 110,
    max_standard_flowrate: 210,
    torque_at_max_operating_differential_pressure: 1455,
    max_operating_differential_pressure: 750,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS120',
    outer_diameter: 5,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 8.2,
    rpg: 0.69,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 9800,
    max_operating_differential_pressure: 2500,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS140',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.81,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 7632,
    max_operating_differential_pressure: 2400,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS170',
    outer_diameter: 5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 9.5,
    rpg: 1.1,
    min_standard_flowrate: 200,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 7685,
    max_operating_differential_pressure: 2900,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS100',
    outer_diameter: 6.5,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.29,
    min_standard_flowrate: 200,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 15540,
    max_operating_differential_pressure: 1500,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS100',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.29,
    min_standard_flowrate: 200,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 15540,
    max_operating_differential_pressure: 1500,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS50',
    outer_diameter: 7,
    stages: 3.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.18,
    min_standard_flowrate: 350,
    max_standard_flowrate: 750,
    torque_at_max_operating_differential_pressure: 16600,
    max_operating_differential_pressure: 1000,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS100',
    outer_diameter: 7,
    stages: 6.1,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.25,
    min_standard_flowrate: 300,
    max_standard_flowrate: 700,
    torque_at_max_operating_differential_pressure: 19422,
    max_operating_differential_pressure: 1800,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS120',
    outer_diameter: 7,
    stages: 6.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.35,
    min_standard_flowrate: 350,
    max_standard_flowrate: 750,
    torque_at_max_operating_differential_pressure: 18260,
    max_operating_differential_pressure: 2200,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS150',
    outer_diameter: 7,
    stages: 7,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.47,
    min_standard_flowrate: 350,
    max_standard_flowrate: 750,
    torque_at_max_operating_differential_pressure: 11880,
    max_operating_differential_pressure: 2200,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS50',
    outer_diameter: 8,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.09,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 15900,
    max_operating_differential_pressure: 600,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS100',
    outer_diameter: 9,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.1,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 40641,
    max_operating_differential_pressure: 1550,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SSS100',
    outer_diameter: 12,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.1,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 40641,
    max_operating_differential_pressure: 1550,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS100',
    outer_diameter: 1.6875,
    stages: 2.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 10.82,
    min_standard_flowrate: 20,
    max_standard_flowrate: 40,
    torque_at_max_operating_differential_pressure: 132,
    max_operating_differential_pressure: 600,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS150',
    outer_diameter: 2.125,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 13.61,
    min_standard_flowrate: 20,
    max_standard_flowrate: 50,
    torque_at_max_operating_differential_pressure: 255,
    max_operating_differential_pressure: 1500,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS150',
    outer_diameter: 2.875,
    stages: 3.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 4.1,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 508,
    max_operating_differential_pressure: 875,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS150 HF',
    outer_diameter: 2.875,
    stages: 3.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 2.22,
    min_standard_flowrate: 126,
    max_standard_flowrate: 167,
    torque_at_max_operating_differential_pressure: 582,
    max_operating_differential_pressure: 700,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS150',
    outer_diameter: 3.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 4.3,
    rpg: 1.61,
    min_standard_flowrate: 80,
    max_standard_flowrate: 180,
    torque_at_max_operating_differential_pressure: 2024,
    max_operating_differential_pressure: 1100,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS150 SR',
    outer_diameter: 3.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 2.2,
    rpg: 1.64,
    min_standard_flowrate: 80,
    max_standard_flowrate: 180,
    torque_at_max_operating_differential_pressure: 1001,
    max_operating_differential_pressure: 550,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS50',
    outer_diameter: 5,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.4,
    rpg: 0.26,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5382,
    max_operating_differential_pressure: 600,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS100',
    outer_diameter: 5,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 3.8,
    rpg: 0.56,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5175,
    max_operating_differential_pressure: 1150,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS170',
    outer_diameter: 5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 5.4,
    rpg: 1.06,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 3375,
    max_operating_differential_pressure: 1350,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS100',
    outer_diameter: 6.25,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.35,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 9828,
    max_operating_differential_pressure: 1200,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS50',
    outer_diameter: 6.5,
    stages: 3.1,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.18,
    min_standard_flowrate: 400,
    max_standard_flowrate: 700,
    torque_at_max_operating_differential_pressure: 10704,
    max_operating_differential_pressure: 800,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS50',
    outer_diameter: 6.75,
    stages: 3.1,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.18,
    min_standard_flowrate: 400,
    max_standard_flowrate: 700,
    torque_at_max_operating_differential_pressure: 10704,
    max_operating_differential_pressure: 800,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS100',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.28,
    min_standard_flowrate: 200,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 12188,
    max_operating_differential_pressure: 1250,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS150',
    outer_diameter: 6.75,
    stages: 6.2,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.49,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 8835,
    max_operating_differential_pressure: 1550,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS100',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 16540,
    max_operating_differential_pressure: 1000,
  },
  {
    family: 'pdm',
    make: 'BICO',
    model: 'SS100',
    outer_diameter: 9,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 400,
    max_standard_flowrate: 950,
    torque_at_max_operating_differential_pressure: 16540,
    max_operating_differential_pressure: 1000,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 3.125,
    stages: 2.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.24,
    min_standard_flowrate: 100,
    max_standard_flowrate: 210,
    torque_at_max_operating_differential_pressure: 740,
    max_operating_differential_pressure: 380,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 4.75,
    stages: 6,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.02,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3690,
    max_operating_differential_pressure: 1350,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 4.75,
    stages: 8.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5978,
    max_operating_differential_pressure: 2280,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 4.75,
    stages: 2.6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.263,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 3500,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 4.75,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.52,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 4450,
    max_operating_differential_pressure: 860,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.642,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 5451,
    max_operating_differential_pressure: 1380,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 5,
    stages: 8,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.84,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 5897,
    max_operating_differential_pressure: 2065,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 5,
    stages: 8.8,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.68,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 8014,
    max_operating_differential_pressure: 2240,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 6.25,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.33,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 8620,
    max_operating_differential_pressure: 720,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 6.5,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.5,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 11110,
    max_operating_differential_pressure: 1930,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 6.75,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.5,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 11110,
    max_operating_differential_pressure: 1930,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 6.75,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.497,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 7750,
    max_operating_differential_pressure: 435,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 6.5,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.29,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 12188,
    max_operating_differential_pressure: 1250,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.29,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 12188,
    max_operating_differential_pressure: 1250,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 7,
    stages: 9.4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.4,
    min_standard_flowrate: 300,
    max_standard_flowrate: 700,
    torque_at_max_operating_differential_pressure: 11729,
    max_operating_differential_pressure: 2030,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 7,
    stages: 6.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.25,
    min_standard_flowrate: 300,
    max_standard_flowrate: 700,
    torque_at_max_operating_differential_pressure: 19010,
    max_operating_differential_pressure: 1960,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 7.75,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 14930,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 8,
    stages: 3.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.087,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 22530,
    max_operating_differential_pressure: 800,
  },
  {
    family: 'pdm',
    make: 'DDS',
    model: '',
    outer_diameter: 9.875,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.13,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 21712,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 4.75,
    stages: 8,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 2.08,
    min_standard_flowrate: 100,
    max_standard_flowrate: 265,
    torque_at_max_operating_differential_pressure: 1365,
    max_operating_differential_pressure: 985,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 4.75,
    stages: 6.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.05,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2146,
    max_operating_differential_pressure: 785,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 4.75,
    stages: 8.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 3050,
    max_operating_differential_pressure: 1420,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 4.75,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.56,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1445,
    max_operating_differential_pressure: 300,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 4.75,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.3,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3900,
    max_operating_differential_pressure: 525,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 4.75,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.56,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2350,
    max_operating_differential_pressure: 465,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 5,
    stages: 2.5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.45,
    min_standard_flowrate: 100,
    max_standard_flowrate: 325,
    torque_at_max_operating_differential_pressure: 5700,
    max_operating_differential_pressure: 1180,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 5,
    stages: 4.5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.8,
    min_standard_flowrate: 100,
    max_standard_flowrate: 315,
    torque_at_max_operating_differential_pressure: 4515,
    max_operating_differential_pressure: 1530,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.8,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 2780,
    max_operating_differential_pressure: 1200,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 6.25,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 200,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 6900,
    max_operating_differential_pressure: 525,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 6.25,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.34,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 5700,
    max_operating_differential_pressure: 880,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 6.5,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.14,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 4500,
    max_operating_differential_pressure: 237,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 6.5,
    stages: 3,
    number_rotor_lobes: 8,
    number_stator_lobes: 9,
    rpg: 0.29,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 3740,
    max_operating_differential_pressure: 380,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 6.75,
    stages: 7,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 0.83,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 2700,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 6.75,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.5,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 5174,
    max_operating_differential_pressure: 915,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.29,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 5956,
    max_operating_differential_pressure: 715,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 6.75,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 200,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 7375,
    max_operating_differential_pressure: 560,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.29,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 3380,
    max_operating_differential_pressure: 410,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 7,
    stages: 2.9,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.21,
    min_standard_flowrate: 300,
    max_standard_flowrate: 650,
    torque_at_max_operating_differential_pressure: 11950,
    max_operating_differential_pressure: 1175,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 7,
    stages: 4.5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.36,
    min_standard_flowrate: 300,
    max_standard_flowrate: 675,
    torque_at_max_operating_differential_pressure: 8750,
    max_operating_differential_pressure: 1395,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 7,
    stages: 7.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.31,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9550,
    max_operating_differential_pressure: 1440,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 8,
    stages: 5.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.26,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 7500,
    max_operating_differential_pressure: 670,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 8,
    stages: 5.2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.24,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 17120,
    max_operating_differential_pressure: 1600,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.17,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 8500,
    max_operating_differential_pressure: 620,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 8,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.1,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 7000,
    max_operating_differential_pressure: 375,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 8,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 6894,
    max_operating_differential_pressure: 410,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 9.63,
    stages: 7.5,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 0.47,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 4508,
    max_operating_differential_pressure: 880,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 9.63,
    stages: 6,
    number_rotor_lobes: 3,
    number_stator_lobes: 4,
    rpg: 0.22,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 9500,
    max_operating_differential_pressure: 730,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 9.63,
    stages: 3,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.12,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 16500,
    max_operating_differential_pressure: 720,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 9.63,
    stages: 3.5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.11,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 32275,
    max_operating_differential_pressure: 1300,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 9.63,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.13,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 13315,
    max_operating_differential_pressure: 720,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 11.25,
    stages: 3.6,
    number_rotor_lobes: 3,
    number_stator_lobes: 4,
    rpg: 0.12,
    min_standard_flowrate: 1000,
    max_standard_flowrate: 1500,
    torque_at_max_operating_differential_pressure: 10200,
    max_operating_differential_pressure: 410,
  },
  {
    family: 'pdm',
    make: 'Halliburton',
    model: '',
    outer_diameter: 11.25,
    stages: 5.5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.09,
    min_standard_flowrate: 900,
    max_standard_flowrate: 1800,
    torque_at_max_operating_differential_pressure: 22000,
    max_operating_differential_pressure: 950,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL',
    outer_diameter: 3.75,
    stages: 6.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.64,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 2.75,
    max_operating_differential_pressure: 1.716,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL-HTS',
    outer_diameter: 4.75,
    stages: 3.1,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.33,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 5.664,
    max_operating_differential_pressure: 699,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL',
    outer_diameter: 4.75,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.58,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 3.873,
    max_operating_differential_pressure: 852,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XXL',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.62,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 5.209,
    max_operating_differential_pressure: 1.226,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XXL',
    outer_diameter: 4.75,
    stages: 8.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.04,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 5.249,
    max_operating_differential_pressure: 1.987,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL',
    outer_diameter: 4.75,
    stages: 6,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.03,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 3.74,
    max_operating_differential_pressure: 1.365,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL',
    outer_diameter: 4.75,
    stages: 11,
    number_rotor_lobes: 3,
    number_stator_lobes: 4,
    rpg: 2.02,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 3.594,
    max_operating_differential_pressure: 2.515,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL-HTS',
    outer_diameter: 6.25,
    stages: 3.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.21,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 9.995,
    max_operating_differential_pressure: 788,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL',
    outer_diameter: 6.25,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.34,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 8.864,
    max_operating_differential_pressure: 1.132,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL-HTS',
    outer_diameter: 6.75,
    stages: 3.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.14,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 13.851,
    max_operating_differential_pressure: 744,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.28,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 11.143,
    max_operating_differential_pressure: 1.173,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XXL',
    outer_diameter: 6.75,
    stages: 6.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.28,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 15.032,
    max_operating_differential_pressure: 1.587,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL-HTS',
    outer_diameter: 7.75,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.08,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 15.237,
    max_operating_differential_pressure: 489,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL',
    outer_diameter: 7.75,
    stages: 4,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.15,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 15.998,
    max_operating_differential_pressure: 903,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL',
    outer_diameter: 7.75,
    stages: 5.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.25,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 13.393,
    max_operating_differential_pressure: 1.195,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL-HY',
    outer_diameter: 9.625,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.08,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 15.237,
    max_operating_differential_pressure: 489,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL-HY',
    outer_diameter: 9.625,
    stages: 4,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.15,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 15.998,
    max_operating_differential_pressure: 903,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL-HY',
    outer_diameter: 9.625,
    stages: 5.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.25,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 13.393,
    max_operating_differential_pressure: 1.195,
  },
  {
    family: 'pdm',
    make: 'MS Directional',
    model: 'XL',
    outer_diameter: 9.625,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.13,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 24.971,
    max_operating_differential_pressure: 1.182,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '1 7/16" 1/2 H/S 3.0 Stage',
    outer_diameter: 1.4375,
    stages: 3,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 52,
    min_standard_flowrate: 22,
    max_standard_flowrate: 40,
    torque_at_max_operating_differential_pressure: 25,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '1 11/16" 5/6 M/L 2.5 Stage',
    outer_diameter: 1.6875,
    stages: 2.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 14.67,
    min_standard_flowrate: 9,
    max_standard_flowrate: 30,
    torque_at_max_operating_differential_pressure: 60,
    max_operating_differential_pressure: 330,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '1 11/16" 5/6 M/L 4.4 Stage',
    outer_diameter: 1.6875,
    stages: 4.4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 11.11,
    min_standard_flowrate: 15,
    max_standard_flowrate: 45,
    torque_at_max_operating_differential_pressure: 140,
    max_operating_differential_pressure: 570,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '1 11/16" 5/6 M/L 5.0 Stage',
    outer_diameter: 1.6875,
    stages: 5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 14.22,
    min_standard_flowrate: 15,
    max_standard_flowrate: 45,
    torque_at_max_operating_differential_pressure: 140,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 1/8" 5/6 M/L 3.0 Stage',
    outer_diameter: 2.125,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 7.17,
    min_standard_flowrate: 18,
    max_standard_flowrate: 60,
    torque_at_max_operating_differential_pressure: 170,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 1/8" 5/6 M/L 6.0 Stage',
    outer_diameter: 2.125,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 12.8,
    min_standard_flowrate: 20,
    max_standard_flowrate: 50,
    torque_at_max_operating_differential_pressure: 170,
    max_operating_differential_pressure: 780,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 3/8" 1/2 H/S 7.0 Stage',
    outer_diameter: 2.375,
    stages: 7,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 27.4,
    min_standard_flowrate: 20,
    max_standard_flowrate: 50,
    torque_at_max_operating_differential_pressure: 95,
    max_operating_differential_pressure: 910,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 3/8" 2/3 M/L 4.0 Stage',
    outer_diameter: 2.375,
    stages: 4,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 13.75,
    min_standard_flowrate: 20,
    max_standard_flowrate: 65,
    torque_at_max_operating_differential_pressure: 90,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 3/8" 4/5 M/L 3.0 Stage',
    outer_diameter: 2.375,
    stages: 3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 10.72,
    min_standard_flowrate: 10,
    max_standard_flowrate: 25,
    torque_at_max_operating_differential_pressure: 100,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 3/8" 5/6 M/L 2.5 Stage',
    outer_diameter: 2.375,
    stages: 2.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 8,
    min_standard_flowrate: 20,
    max_standard_flowrate: 50,
    torque_at_max_operating_differential_pressure: 110,
    max_operating_differential_pressure: 330,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 3/8" 5/6 M/L 5.2 Stage',
    outer_diameter: 2.375,
    stages: 5.2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 7.4,
    min_standard_flowrate: 20,
    max_standard_flowrate: 50,
    torque_at_max_operating_differential_pressure: 250,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 3/8" 7/8 M/L 4.0 Stage',
    outer_diameter: 2.375,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 5.38,
    min_standard_flowrate: 20,
    max_standard_flowrate: 80,
    torque_at_max_operating_differential_pressure: 250,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 1/2 H/S 5.2 Stage',
    outer_diameter: 2.375,
    stages: 5.2,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 11.29,
    min_standard_flowrate: 25,
    max_standard_flowrate: 70,
    torque_at_max_operating_differential_pressure: 180,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 1/2 H/S 7.0 Stage',
    outer_diameter: 2.375,
    stages: 7,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 15,
    min_standard_flowrate: 25,
    max_standard_flowrate: 70,
    torque_at_max_operating_differential_pressure: 180,
    max_operating_differential_pressure: 910,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 3/4 M/L 4.0 Stage',
    outer_diameter: 2.375,
    stages: 4,
    number_rotor_lobes: 3,
    number_stator_lobes: 4,
    rpg: 9.17,
    min_standard_flowrate: 10,
    max_standard_flowrate: 40,
    torque_at_max_operating_differential_pressure: 170,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 4/5 M/L 3.0 Stage',
    outer_diameter: 2.375,
    stages: 3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 5.71,
    min_standard_flowrate: 25,
    max_standard_flowrate: 70,
    torque_at_max_operating_differential_pressure: 210,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 5/6 M/L 3.3 Stage',
    outer_diameter: 2.875,
    stages: 3.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 6,
    min_standard_flowrate: 20,
    max_standard_flowrate: 80,
    torque_at_max_operating_differential_pressure: 190,
    max_operating_differential_pressure: 430,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 5/6 M/L 4.7 Stage',
    outer_diameter: 2.875,
    stages: 4.7,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 3.76,
    min_standard_flowrate: 50,
    max_standard_flowrate: 125,
    torque_at_max_operating_differential_pressure: 440,
    max_operating_differential_pressure: 610,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 5/6 M/L 4.7 Stage - 4°',
    outer_diameter: 2.875,
    stages: 4.7,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 3.76,
    min_standard_flowrate: 50,
    max_standard_flowrate: 125,
    torque_at_max_operating_differential_pressure: 440,
    max_operating_differential_pressure: 610,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 5/6 M/L 7.0 Stage',
    outer_diameter: 2.875,
    stages: 7,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 5.75,
    min_standard_flowrate: 20,
    max_standard_flowrate: 80,
    torque_at_max_operating_differential_pressure: 440,
    max_operating_differential_pressure: 910,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 5/6 M/L 7.0 Stage-4°',
    outer_diameter: 2.875,
    stages: 7,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 5.75,
    min_standard_flowrate: 20,
    max_standard_flowrate: 80,
    torque_at_max_operating_differential_pressure: 440,
    max_operating_differential_pressure: 910,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 7/8 M/L 1.5 Stage',
    outer_diameter: 2.875,
    stages: 1.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 3.08,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 140,
    max_operating_differential_pressure: 200,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 7/8 M/L 1.5 Stage-4°',
    outer_diameter: 2.875,
    stages: 1.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 3.08,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 140,
    max_operating_differential_pressure: 200,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 7/8 M/L 2.0 Stage(Air)',
    outer_diameter: 2.875,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 2.05,
    min_standard_flowrate: 30,
    max_standard_flowrate: 70,
    torque_at_max_operating_differential_pressure: 340,
    max_operating_differential_pressure: 260,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 7/8 M/L 2.0 Stage-4°',
    outer_diameter: 2.875,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 2.05,
    min_standard_flowrate: 25,
    max_standard_flowrate: 70,
    torque_at_max_operating_differential_pressure: 340,
    max_operating_differential_pressure: 260,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 7/8 M/L 2.5 Stage',
    outer_diameter: 2.875,
    stages: 2.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 3.29,
    min_standard_flowrate: 25,
    max_standard_flowrate: 70,
    torque_at_max_operating_differential_pressure: 260,
    max_operating_differential_pressure: 330,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '2 7/8" 7/8 M/L 2.5 Stage-4°',
    outer_diameter: 2.875,
    stages: 2.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 3.29,
    min_standard_flowrate: 25,
    max_standard_flowrate: 70,
    torque_at_max_operating_differential_pressure: 260,
    max_operating_differential_pressure: 330,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 1/8" 5/6 M/L 3.5 Stage',
    outer_diameter: 3.125,
    stages: 3.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 2.24,
    min_standard_flowrate: 75,
    max_standard_flowrate: 175,
    torque_at_max_operating_differential_pressure: 570,
    max_operating_differential_pressure: 460,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 1/8" 7/8 M/L 3.0 Stage',
    outer_diameter: 3.125,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.8,
    min_standard_flowrate: 80,
    max_standard_flowrate: 140,
    torque_at_max_operating_differential_pressure: 560,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 1/8" 7/8 M/L 4.0 Stage',
    outer_diameter: 3.125,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 3.68,
    min_standard_flowrate: 70,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 340,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 3/8" 1/2 H/S 5.5 Stage',
    outer_diameter: 3.375,
    stages: 5.5,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 6.5,
    min_standard_flowrate: 25,
    max_standard_flowrate: 100,
    torque_at_max_operating_differential_pressure: 330,
    max_operating_differential_pressure: 720,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 3/8" 4/5 M/L 5.0 Stage',
    outer_diameter: 3.375,
    stages: 5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 3.18,
    min_standard_flowrate: 35,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 550,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 3/8" 7/8 M/L 3.0 Stage',
    outer_diameter: 3.375,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.64,
    min_standard_flowrate: 35,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 610,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 1/2" 4/5 M/L 4.0 Stage',
    outer_diameter: 3.5,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 4,
    rpg: 2.69,
    min_standard_flowrate: 70,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 590,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 1/2" 5/6 M/L 2.0 Stage',
    outer_diameter: 3.5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 2,
    rpg: 2.44,
    min_standard_flowrate: 70,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 290,
    max_operating_differential_pressure: 260,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 1/2" 5/6 M/L 2.0 Stage-4°',
    outer_diameter: 3.5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 2,
    rpg: 2.44,
    min_standard_flowrate: 70,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 290,
    max_operating_differential_pressure: 260,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 1/2" 5/6 M/L 3.0 Stage',
    outer_diameter: 3.5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 3,
    rpg: 2.38,
    min_standard_flowrate: 70,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 480,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 1/2" 7/8 M/L 3.8 Stage',
    outer_diameter: 3.5,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 3.8,
    rpg: 2.31,
    min_standard_flowrate: 70,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 810,
    max_operating_differential_pressure: 490,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 1/2" 7/8 M/L 4.3 Stage',
    outer_diameter: 3.5,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 4.3,
    rpg: 1.85,
    min_standard_flowrate: 50,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 800,
    max_operating_differential_pressure: 560,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 3/4" 1/2 H/S 4.4 Stage',
    outer_diameter: 3.75,
    stages: 1,
    number_rotor_lobes: 2,
    number_stator_lobes: 4.4,
    rpg: 4.07,
    min_standard_flowrate: 65,
    max_standard_flowrate: 140,
    torque_at_max_operating_differential_pressure: 420,
    max_operating_differential_pressure: 570,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 3/4" 3/4 M/L 9.0 Stage',
    outer_diameter: 3.75,
    stages: 3,
    number_rotor_lobes: 4,
    number_stator_lobes: 9,
    rpg: 5.73,
    min_standard_flowrate: 75,
    max_standard_flowrate: 150,
    torque_at_max_operating_differential_pressure: 630,
    max_operating_differential_pressure: 1170,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 3/4" 4/5 M/L 3.5 Stage',
    outer_diameter: 3.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 3.5,
    rpg: 1.56,
    min_standard_flowrate: 70,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 790,
    max_operating_differential_pressure: 460,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 3/4" 5/6 M/L 5.0 Stage(OS)',
    outer_diameter: 3.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 5,
    rpg: 1.44,
    min_standard_flowrate: 70,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 1100,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 3/4" 6/7 M/L 3.0 Stage',
    outer_diameter: 3.75,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 3,
    rpg: 0.8,
    min_standard_flowrate: 80,
    max_standard_flowrate: 200,
    torque_at_max_operating_differential_pressure: 1170,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 3/4" 7/8 M/L 2.0 Stage',
    outer_diameter: 3.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2,
    rpg: 0.56,
    min_standard_flowrate: 100,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 1160,
    max_operating_differential_pressure: 260,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 3/4" 7/8 M/L 2.3 Stage',
    outer_diameter: 3.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.3,
    rpg: 0.88,
    min_standard_flowrate: 100,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 920,
    max_operating_differential_pressure: 300,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 3/4" 7/8 M/L 2.3 Stage',
    outer_diameter: 3.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.3,
    rpg: 0.88,
    min_standard_flowrate: 100,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 920,
    max_operating_differential_pressure: 300,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 3/4" 7/8 M/L 6.7 Stage',
    outer_diameter: 3.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 6.7,
    rpg: 1.75,
    min_standard_flowrate: 100,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 1260,
    max_operating_differential_pressure: 870,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '3 3/4" 7/8 M/L 10.1 Stage',
    outer_diameter: 3.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 10.1,
    rpg: 1.98,
    min_standard_flowrate: 80,
    max_standard_flowrate: 210,
    torque_at_max_operating_differential_pressure: 1830,
    max_operating_differential_pressure: 1310,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 1/2 H/S 3.0 Stage',
    outer_diameter: 4.75,
    stages: 1,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 2.25,
    min_standard_flowrate: 110,
    max_standard_flowrate: 200,
    torque_at_max_operating_differential_pressure: 510,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 1/2 H/S 4.0 Stage',
    outer_diameter: 4.75,
    stages: 1,
    number_rotor_lobes: 2,
    number_stator_lobes: 4,
    rpg: 3.1,
    min_standard_flowrate: 50,
    max_standard_flowrate: 200,
    torque_at_max_operating_differential_pressure: 500,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 1/2 H/S 6.5 Stage',
    outer_diameter: 4.75,
    stages: 1,
    number_rotor_lobes: 2,
    number_stator_lobes: 6.5,
    rpg: 2.96,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 850,
    max_operating_differential_pressure: 850,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 2/3 M/L 8.0 Stage',
    outer_diameter: 4.75,
    stages: 2,
    number_rotor_lobes: 3,
    number_stator_lobes: 8,
    rpg: 1.98,
    min_standard_flowrate: 100,
    max_standard_flowrate: 265,
    torque_at_max_operating_differential_pressure: 1300,
    max_operating_differential_pressure: 1040,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 3/4 M/L 9.9 Stage',
    outer_diameter: 4.75,
    stages: 3,
    number_rotor_lobes: 4,
    number_stator_lobes: 9.9,
    rpg: 2.3,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1740,
    max_operating_differential_pressure: 1290,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 4/5 M/L 3.5 Stage',
    outer_diameter: 4.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 3.5,
    rpg: 1.08,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1210,
    max_operating_differential_pressure: 460,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 4/5 M/L 6.0 Stage',
    outer_diameter: 4.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.08,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2080,
    max_operating_differential_pressure: 780,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 4/5 M/L 6.3 Stage',
    outer_diameter: 4.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6.3,
    rpg: 1.08,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2180,
    max_operating_differential_pressure: 820,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 5/6 M/L 3.0 Stage',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 3,
    rpg: 1.12,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 940,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 5/6 M/L 3.0 Stage-4°',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 3,
    rpg: 1.12,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 940,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 5/6 M/L 8.3 Stage',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 8.3,
    rpg: 1.09,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 2890,
    max_operating_differential_pressure: 1080,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 6/7 M/L 6.0 Stage',
    outer_diameter: 4.75,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 6,
    rpg: 0.87,
    min_standard_flowrate: 200,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 2230,
    max_operating_differential_pressure: 780,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 7/8 M/L 2.0 Stage(Air)',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2,
    rpg: 0.32,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2150,
    max_operating_differential_pressure: 260,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 7/8 M/L 2.0 Stage-4°',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2,
    rpg: 0.32,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 940,
    max_operating_differential_pressure: 260,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 7/8 M/L 2.2 Stage',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.2,
    rpg: 0.56,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1330,
    max_operating_differential_pressure: 290,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 7/8 M/L 2.2 Stage-4°',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.2,
    rpg: 0.56,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1330,
    max_operating_differential_pressure: 290,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '4 3/4" 7/8 M/L 3.8 Stage',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 3.8,
    rpg: 0.56,
    min_standard_flowrate: 160,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2430,
    max_operating_differential_pressure: 490,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '5" 6/7 M/L 6.0 Stage',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 6,
    rpg: 0.86,
    min_standard_flowrate: 200,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 2250,
    max_operating_differential_pressure: 780,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '5" 6/7 M/L 7.0 Stage',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 7,
    rpg: 0.86,
    min_standard_flowrate: 200,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 2620,
    max_operating_differential_pressure: 910,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '5" 6/7 M/L 8.0 Stage',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.86,
    min_standard_flowrate: 200,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 3000,
    max_operating_differential_pressure: 1040,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 1/4" 1/2 H/S 4.0 Stage',
    outer_diameter: 6.25,
    stages: 4,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 1.31,
    min_standard_flowrate: 170,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 1160,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 1/4" 4/5 M/L 4.3 Stage',
    outer_diameter: 6.25,
    stages: 4.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.68,
    min_standard_flowrate: 160,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 2370,
    max_operating_differential_pressure: 560,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 1/4" 4/5 M/L 7.5 Stage',
    outer_diameter: 6.25,
    stages: 7.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.68,
    min_standard_flowrate: 160,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 4170,
    max_operating_differential_pressure: 980,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 1/4" 5/6 M/L 5.0 Stage',
    outer_diameter: 6.25,
    stages: 5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.73,
    min_standard_flowrate: 220,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 2820,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 1/4" 5/6 M/L 5.5 Stage',
    outer_diameter: 6.25,
    stages: 5.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.46,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 4170,
    max_operating_differential_pressure: 715,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 1/4" 7/8 M/L 2.8 Stage',
    outer_diameter: 6.25,
    stages: 2.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.34,
    min_standard_flowrate: 220,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 2770,
    max_operating_differential_pressure: 360,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 1/4" 7/8 M/L 2.9 Stage',
    outer_diameter: 6.25,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 5590,
    max_operating_differential_pressure: 380,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 1/4" 7/8 M/L 3.0 Stage',
    outer_diameter: 6.25,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.39,
    min_standard_flowrate: 220,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 3120,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 1/4" 7/8 M/L 4.8 Stage',
    outer_diameter: 6.25,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.35,
    min_standard_flowrate: 160,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 4840,
    max_operating_differential_pressure: 620,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 1/2 H/S 3.0 Stage',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 0.97,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 990,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 1/2 H/S 4.0 Stage',
    outer_diameter: 6.75,
    stages: 4,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 1,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 1580,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 2/3 M/L 7.0 Stage(OS)',
    outer_diameter: 6.75,
    stages: 7,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 0.85,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 2820,
    max_operating_differential_pressure: 910,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 4/5 M/L 4.8 Stage',
    outer_diameter: 6.75,
    stages: 4.8,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.52,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 3440,
    max_operating_differential_pressure: 620,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 4/5 M/L 7.0 Stage',
    outer_diameter: 6.75,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.5,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 5160,
    max_operating_differential_pressure: 910,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 5/6 M/L 5.0 Stage',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.47,
    min_standard_flowrate: 210,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 4380,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 6/7 M/L 5.0 Stage',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.29,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 5410,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 6/7 M/L 6.0 Stage',
    outer_diameter: 6.75,
    stages: 6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.29,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 6500,
    max_operating_differential_pressure: 780,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 7/8 M/L 2.0 Stage(Air)',
    outer_diameter: 6.75,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.14,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 4730,
    max_operating_differential_pressure: 260,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 7/8 M/L 2.9 Stage',
    outer_diameter: 6.75,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 7450,
    max_operating_differential_pressure: 515,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 7/8 M/L 3.0 Stage',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.28,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 3490,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 7/8 M/L 3.5 Stage',
    outer_diameter: 6.75,
    stages: 3.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.15,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 7830,
    max_operating_differential_pressure: 460,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 7/8 M/L 5.0 Stage',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.28,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 5950,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 7/8 M/L 5.7 Stage',
    outer_diameter: 6.75,
    stages: 5.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.24,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 8010,
    max_operating_differential_pressure: 740,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '6 3/4" 7/8 M/L 6.4 Stage',
    outer_diameter: 6.75,
    stages: 6.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.31,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 6340,
    max_operating_differential_pressure: 830,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '7" 7/8 M/L 6.0 Stage',
    outer_diameter: 7,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.31,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 5940,
    max_operating_differential_pressure: 780,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '7" 7/8 M/L 7.5 Stage',
    outer_diameter: 7,
    stages: 7.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.31,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 7420,
    max_operating_differential_pressure: 975,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '7 3/4" (8") 1/2 H/S 4.0 Stage',
    outer_diameter: 7.75,
    stages: 4,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 0.7,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 2210,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '7 3/4" (8") 4/5 M/L 3.6 Stage',
    outer_diameter: 7.75,
    stages: 3.6,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.26,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 5160,
    max_operating_differential_pressure: 470,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '7 3/4" (8") 4/5 M/L 5.3 Stage',
    outer_diameter: 7.75,
    stages: 5.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.26,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 7680,
    max_operating_differential_pressure: 690,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '7 3/4" (8") 5/6 M/L 5.0 Stage',
    outer_diameter: 7.75,
    stages: 5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.29,
    min_standard_flowrate: 510,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 5410,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '7 3/4" (8") 6/7 M/L 4.0 Stage',
    outer_diameter: 7.75,
    stages: 4,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.17,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 7680,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '7 3/4" (8") 7/8 M/L 2.0 Stage',
    outer_diameter: 7.75,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.08,
    min_standard_flowrate: 650,
    max_standard_flowrate: 1100,
    torque_at_max_operating_differential_pressure: 9040,
    max_operating_differential_pressure: 260,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '7 3/4" (8") 7/8 M/L 3.0 Stage',
    outer_diameter: 7.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 6220,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '7 3/4" (8") 7/8 M/L 4.0 Stage',
    outer_diameter: 7.75,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 8660,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '8" 6/7 M/L 5.0 Stage',
    outer_diameter: 8,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.17,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 9590,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '9 5/8" 1/2 H/S 4.0 Stage',
    outer_diameter: 9.625,
    stages: 4,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 0.46,
    min_standard_flowrate: 510,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 3410,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '9 5/8" 2/3 M/L 7.5 Stage',
    outer_diameter: 9.625,
    stages: 7.5,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 0.49,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 5490,
    max_operating_differential_pressure: 975,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '9 5/8" 3/4 M/L 4.5 Stage',
    outer_diameter: 9.625,
    stages: 4.5,
    number_rotor_lobes: 3,
    number_stator_lobes: 4,
    rpg: 0.23,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 7450,
    max_operating_differential_pressure: 590,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '9 5/8" 3/4 M/L 6.0 Stage',
    outer_diameter: 9.625,
    stages: 6,
    number_rotor_lobes: 3,
    number_stator_lobes: 4,
    rpg: 0.22,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 10170,
    max_operating_differential_pressure: 780,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '9 5/8" 5/6 M/L 3.0 Stage',
    outer_diameter: 9.625,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.11,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 9450,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '9 5/8" 5/6 M/L 4.0 Stage',
    outer_diameter: 9.625,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.12,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 12580,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '9 5/8" 6/7 M/L 5.0 Stage',
    outer_diameter: 9.625,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.13,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 12040,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '9 5/8" 6/7 M/L 6.0 Stage',
    outer_diameter: 9.625,
    stages: 6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.13,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 14450,
    max_operating_differential_pressure: 780,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '9 5/8" 7/8 M/L 5.7 Stage',
    outer_diameter: 9.625,
    stages: 5.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.12,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 16230,
    max_operating_differential_pressure: 740,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '11 1/4" 3/4 M/L 3.6 Stage',
    outer_diameter: 11.25,
    stages: 3,
    number_rotor_lobes: 4,
    number_stator_lobes: 3.6,
    rpg: 0.12,
    min_standard_flowrate: 1050,
    max_standard_flowrate: 1500,
    torque_at_max_operating_differential_pressure: 11330,
    max_operating_differential_pressure: 470,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '11 1/4" 5/6 M/L 4.6 Stage',
    outer_diameter: 11.25,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 4.6,
    rpg: 0.09,
    min_standard_flowrate: 900,
    max_standard_flowrate: 1800,
    torque_at_max_operating_differential_pressure: 19010,
    max_operating_differential_pressure: 600,
  },
  {
    family: 'pdm',
    make: 'NOV',
    model: '11 1/4" 6/7 M/L 3.0 Stage',
    outer_diameter: 11.25,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 3,
    rpg: 0.1,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 12090,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-1A',
    outer_diameter: 4.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6.3,
    rpg: 1.02,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2580,
    max_operating_differential_pressure: 950,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'HSN-38',
    outer_diameter: 4.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6.3,
    rpg: 1.02,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2580,
    max_operating_differential_pressure: 950,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-HR',
    outer_diameter: 4.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6.3,
    rpg: 1.02,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3870,
    max_operating_differential_pressure: 1420,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-1A',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 6.7,
    rpg: 0.946,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 2700,
    max_operating_differential_pressure: 1010,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'HSN-38',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 6.7,
    rpg: 0.946,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 2700,
    max_operating_differential_pressure: 1010,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-HR',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 6.7,
    rpg: 0.946,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 4060,
    max_operating_differential_pressure: 1510,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-1A',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 8.3,
    rpg: 1,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 3210,
    max_operating_differential_pressure: 1250,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'HSN-38',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 8.3,
    rpg: 1,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 3210,
    max_operating_differential_pressure: 1250,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-HR',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 8.3,
    rpg: 1,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 4810,
    max_operating_differential_pressure: 1870,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-1A',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.2,
    rpg: 0.522,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1560,
    max_operating_differential_pressure: 330,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'HSN-38',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.2,
    rpg: 0.522,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1560,
    max_operating_differential_pressure: 330,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-HR',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.2,
    rpg: 0.522,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2350,
    max_operating_differential_pressure: 500,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-1A',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.6,
    rpg: 0.263,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 3500,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'HSN-38',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.6,
    rpg: 0.263,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 3500,
    max_operating_differential_pressure: 390,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-HR',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.6,
    rpg: 0.263,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5250,
    max_operating_differential_pressure: 590,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-1A',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 3.8,
    rpg: 0.521,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2960,
    max_operating_differential_pressure: 570,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'HSN-38',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 3.8,
    rpg: 0.521,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2960,
    max_operating_differential_pressure: 570,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-HR',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 3.8,
    rpg: 0.521,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 4450,
    max_operating_differential_pressure: 860,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-1A',
    outer_diameter: 6.25,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.33,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 5740,
    max_operating_differential_pressure: 720,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'HSN-38',
    outer_diameter: 6.25,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.33,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 5740,
    max_operating_differential_pressure: 720,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-HR',
    outer_diameter: 6.25,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.33,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 8620,
    max_operating_differential_pressure: 1080,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-1A',
    outer_diameter: 6.5,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 6400,
    max_operating_differential_pressure: 440,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'HSN-38',
    outer_diameter: 6.5,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 6400,
    max_operating_differential_pressure: 440,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-HR',
    outer_diameter: 6.5,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 9600,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-1A',
    outer_diameter: 6.5,
    stages: 3.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 7700,
    max_operating_differential_pressure: 500,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'HSN-38',
    outer_diameter: 6.5,
    stages: 3.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 7700,
    max_operating_differential_pressure: 500,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-HR',
    outer_diameter: 6.5,
    stages: 3.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 11550,
    max_operating_differential_pressure: 740,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-1A',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 6980,
    max_operating_differential_pressure: 750,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'HSN-38',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 6980,
    max_operating_differential_pressure: 750,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-HR',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10460,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-1A',
    outer_diameter: 6.75,
    stages: 5.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.242,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9150,
    max_operating_differential_pressure: 860,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'HSN-38',
    outer_diameter: 6.75,
    stages: 5.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.242,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9150,
    max_operating_differential_pressure: 860,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-HR',
    outer_diameter: 6.75,
    stages: 5.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.242,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 13720,
    max_operating_differential_pressure: 1280,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-1A',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 9950,
    max_operating_differential_pressure: 600,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'HSN-38',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 9950,
    max_operating_differential_pressure: 600,
  },
  {
    family: 'pdm',
    make: 'ProDirectional',
    model: 'NBR-HR',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 14930,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A213M XP',
    outer_diameter: 2.13,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 6,
    rpg: 12.8,
    min_standard_flowrate: 20,
    max_standard_flowrate: 50,
    torque_at_max_operating_differential_pressure: 280,
    max_operating_differential_pressure: 1200,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A238M SP',
    outer_diameter: 2.38,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 2.5,
    rpg: 7.9,
    min_standard_flowrate: 20,
    max_standard_flowrate: 50,
    torque_at_max_operating_differential_pressure: 195,
    max_operating_differential_pressure: 500,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A238M SP',
    outer_diameter: 2.38,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 3.5,
    rpg: 7.38,
    min_standard_flowrate: 20,
    max_standard_flowrate: 80,
    torque_at_max_operating_differential_pressure: 275,
    max_operating_differential_pressure: 700,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A238M XP',
    outer_diameter: 2.38,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 5.2,
    rpg: 7.9,
    min_standard_flowrate: 20,
    max_standard_flowrate: 50,
    torque_at_max_operating_differential_pressure: 420,
    max_operating_differential_pressure: 1050,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A287M SP',
    outer_diameter: 2.88,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 3.3,
    rpg: 5.81,
    min_standard_flowrate: 20,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 330,
    max_operating_differential_pressure: 675,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A287M XP',
    outer_diameter: 2.88,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 5.81,
    min_standard_flowrate: 20,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 700,
    max_operating_differential_pressure: 1400,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A287M SP',
    outer_diameter: 2.88,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 3.2,
    rpg: 4.17,
    min_standard_flowrate: 30,
    max_standard_flowrate: 90,
    torque_at_max_operating_differential_pressure: 465,
    max_operating_differential_pressure: 660,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A287M SP',
    outer_diameter: 2.88,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 3.7,
    rpg: 3.54,
    min_standard_flowrate: 40,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 540,
    max_operating_differential_pressure: 760,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A287M AD',
    outer_diameter: 2.88,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2,
    rpg: 2.17,
    min_standard_flowrate: 60,
    max_standard_flowrate: 180,
    torque_at_max_operating_differential_pressure: 540,
    max_operating_differential_pressure: 420,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A313M XC',
    outer_diameter: 3.13,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2,
    rpg: 3.83,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 280,
    max_operating_differential_pressure: 410,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A313M XC',
    outer_diameter: 3.13,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.9,
    rpg: 3.83,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 400,
    max_operating_differential_pressure: 600,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A313M XF',
    outer_diameter: 3.13,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2,
    rpg: 3.83,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 280,
    max_operating_differential_pressure: 410,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A313S SP',
    outer_diameter: 3.13,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 3.5,
    rpg: 2.19,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 875,
    max_operating_differential_pressure: 700,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A313S GT',
    outer_diameter: 3.13,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 5.2,
    rpg: 2.38,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 1300,
    max_operating_differential_pressure: 1050,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A350M SP',
    outer_diameter: 3.5,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 5,
    rpg: 3.18,
    min_standard_flowrate: 30,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 875,
    max_operating_differential_pressure: 980,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A350M SP',
    outer_diameter: 3.5,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 3,
    rpg: 1.5,
    min_standard_flowrate: 30,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 960,
    max_operating_differential_pressure: 575,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A350S SP',
    outer_diameter: 3.5,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 5,
    rpg: 3.18,
    min_standard_flowrate: 30,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 875,
    max_operating_differential_pressure: 980,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A350S SP',
    outer_diameter: 3.5,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 3,
    rpg: 1.5,
    min_standard_flowrate: 30,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 960,
    max_operating_differential_pressure: 575,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A375M XC',
    outer_diameter: 3.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2,
    rpg: 1.87,
    min_standard_flowrate: 130,
    max_standard_flowrate: 190,
    torque_at_max_operating_differential_pressure: 600,
    max_operating_differential_pressure: 410,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A375M XC',
    outer_diameter: 3.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 3.5,
    rpg: 1.87,
    min_standard_flowrate: 130,
    max_standard_flowrate: 190,
    torque_at_max_operating_differential_pressure: 1050,
    max_operating_differential_pressure: 720,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A375M XF',
    outer_diameter: 3.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2,
    rpg: 1.87,
    min_standard_flowrate: 130,
    max_standard_flowrate: 190,
    torque_at_max_operating_differential_pressure: 600,
    max_operating_differential_pressure: 410,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475M SP',
    outer_diameter: 4.75,
    stages: 1,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 2.18,
    min_standard_flowrate: 100,
    max_standard_flowrate: 200,
    torque_at_max_operating_differential_pressure: 530,
    max_operating_differential_pressure: 400,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475M HS',
    outer_diameter: 4.75,
    stages: 2,
    number_rotor_lobes: 3,
    number_stator_lobes: 10.5,
    rpg: 2.26,
    min_standard_flowrate: 100,
    max_standard_flowrate: 265,
    torque_at_max_operating_differential_pressure: 2550,
    max_operating_differential_pressure: 1850,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475M SP',
    outer_diameter: 4.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 3.5,
    rpg: 1.04,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1900,
    max_operating_differential_pressure: 690,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475M XP',
    outer_diameter: 4.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.04,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3200,
    max_operating_differential_pressure: 1180,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475M GT',
    outer_diameter: 4.75,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8.3,
    rpg: 1.04,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 4600,
    max_operating_differential_pressure: 1650,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475M SP',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.2,
    rpg: 0.54,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2100,
    max_operating_differential_pressure: 450,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475M XP',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 3.8,
    rpg: 0.54,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3750,
    max_operating_differential_pressure: 780,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475M XC',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2,
    rpg: 0.98,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1100,
    max_operating_differential_pressure: 410,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475M XF',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2,
    rpg: 0.98,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1100,
    max_operating_differential_pressure: 410,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475M AD',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2,
    rpg: 0.33,
    min_standard_flowrate: 30,
    max_standard_flowrate: 700,
    torque_at_max_operating_differential_pressure: 3000,
    max_operating_differential_pressure: 360,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475S SP',
    outer_diameter: 4.75,
    stages: 1,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 2.2,
    min_standard_flowrate: 100,
    max_standard_flowrate: 200,
    torque_at_max_operating_differential_pressure: 530,
    max_operating_differential_pressure: 440,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475S HS',
    outer_diameter: 4.75,
    stages: 2,
    number_rotor_lobes: 3,
    number_stator_lobes: 10.5,
    rpg: 2.26,
    min_standard_flowrate: 100,
    max_standard_flowrate: 265,
    torque_at_max_operating_differential_pressure: 2550,
    max_operating_differential_pressure: 1850,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475S SP',
    outer_diameter: 4.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 3.5,
    rpg: 1.04,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1900,
    max_operating_differential_pressure: 700,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475S XP',
    outer_diameter: 4.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.04,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3200,
    max_operating_differential_pressure: 1200,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475S GT',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 8.3,
    rpg: 1.04,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 4600,
    max_operating_differential_pressure: 1650,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475S SP',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2.2,
    rpg: 0.54,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2100,
    max_operating_differential_pressure: 450,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475S XP',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 3.8,
    rpg: 0.54,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3750,
    max_operating_differential_pressure: 780,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A475S AD',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 2,
    rpg: 0.33,
    min_standard_flowrate: 300,
    max_standard_flowrate: 700,
    torque_at_max_operating_differential_pressure: 3000,
    max_operating_differential_pressure: 410,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A500M HS',
    outer_diameter: 5,
    stages: 2,
    number_rotor_lobes: 3,
    number_stator_lobes: 10.5,
    rpg: 2.26,
    min_standard_flowrate: 100,
    max_standard_flowrate: 265,
    torque_at_max_operating_differential_pressure: 2550,
    max_operating_differential_pressure: 1850,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A500M HF',
    outer_diameter: 5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 5.2,
    rpg: 0.63,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 4400,
    max_operating_differential_pressure: 980,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A500M GT',
    outer_diameter: 5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 8.3,
    rpg: 1.04,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 4500,
    max_operating_differential_pressure: 1650,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A625S SP',
    outer_diameter: 6.25,
    stages: 4,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 1.29,
    min_standard_flowrate: 230,
    max_standard_flowrate: 450,
    torque_at_max_operating_differential_pressure: 1400,
    max_operating_differential_pressure: 625,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A625S SP',
    outer_diameter: 6.25,
    stages: 4.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.66,
    min_standard_flowrate: 100,
    max_standard_flowrate: 265,
    torque_at_max_operating_differential_pressure: 3700,
    max_operating_differential_pressure: 850,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A625S XP',
    outer_diameter: 6.25,
    stages: 7.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.66,
    min_standard_flowrate: 100,
    max_standard_flowrate: 265,
    torque_at_max_operating_differential_pressure: 6300,
    max_operating_differential_pressure: 1450,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A625S SP',
    outer_diameter: 6.25,
    stages: 2.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.34,
    min_standard_flowrate: 50,
    max_standard_flowrate: 135,
    torque_at_max_operating_differential_pressure: 4400,
    max_operating_differential_pressure: 580,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A625S XP',
    outer_diameter: 6.25,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.34,
    min_standard_flowrate: 50,
    max_standard_flowrate: 135,
    torque_at_max_operating_differential_pressure: 7600,
    max_operating_differential_pressure: 980,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A650S GT',
    outer_diameter: 6.5,
    stages: 8.2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.42,
    min_standard_flowrate: 125,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 10500,
    max_operating_differential_pressure: 1650,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A650S AD',
    outer_diameter: 6.5,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.14,
    min_standard_flowrate: 60,
    max_standard_flowrate: 115,
    torque_at_max_operating_differential_pressure: 6800,
    max_operating_differential_pressure: 380,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675M SP',
    outer_diameter: 6.75,
    stages: 4,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 0.93,
    min_standard_flowrate: 180,
    max_standard_flowrate: 465,
    torque_at_max_operating_differential_pressure: 1700,
    max_operating_differential_pressure: 510,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675M XP',
    outer_diameter: 6.75,
    stages: 8,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 0.87,
    min_standard_flowrate: 260,
    max_standard_flowrate: 520,
    torque_at_max_operating_differential_pressure: 3700,
    max_operating_differential_pressure: 1075,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675M HS',
    outer_diameter: 6.75,
    stages: 10.7,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 1,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 5600,
    max_operating_differential_pressure: 1900,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675M SP',
    outer_diameter: 6.75,
    stages: 4.8,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.5,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5400,
    max_operating_differential_pressure: 920,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675M XP',
    outer_diameter: 6.75,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.5,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 7800,
    max_operating_differential_pressure: 1400,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675M SP',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.28,
    min_standard_flowrate: 85,
    max_standard_flowrate: 165,
    torque_at_max_operating_differential_pressure: 5700,
    max_operating_differential_pressure: 620,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675M XP',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.28,
    min_standard_flowrate: 85,
    max_standard_flowrate: 165,
    torque_at_max_operating_differential_pressure: 9500,
    max_operating_differential_pressure: 1025,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675M AD',
    outer_diameter: 6.75,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.14,
    min_standard_flowrate: 60,
    max_standard_flowrate: 115,
    torque_at_max_operating_differential_pressure: 6800,
    max_operating_differential_pressure: 380,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675S SP',
    outer_diameter: 6.75,
    stages: 4,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 0.93,
    min_standard_flowrate: 180,
    max_standard_flowrate: 465,
    torque_at_max_operating_differential_pressure: 1700,
    max_operating_differential_pressure: 510,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675S XP',
    outer_diameter: 6.75,
    stages: 8,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 0.87,
    min_standard_flowrate: 260,
    max_standard_flowrate: 520,
    torque_at_max_operating_differential_pressure: 3700,
    max_operating_differential_pressure: 1075,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675S HS',
    outer_diameter: 6.75,
    stages: 10.7,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 1,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 5600,
    max_operating_differential_pressure: 1900,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675S SP',
    outer_diameter: 6.75,
    stages: 4.8,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.5,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5400,
    max_operating_differential_pressure: 920,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675S XP',
    outer_diameter: 6.75,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.5,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 7800,
    max_operating_differential_pressure: 1400,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675S SP',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.28,
    min_standard_flowrate: 85,
    max_standard_flowrate: 165,
    torque_at_max_operating_differential_pressure: 5700,
    max_operating_differential_pressure: 620,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675S XP',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.28,
    min_standard_flowrate: 85,
    max_standard_flowrate: 165,
    torque_at_max_operating_differential_pressure: 9500,
    max_operating_differential_pressure: 1025,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A675S AD',
    outer_diameter: 6.75,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.14,
    min_standard_flowrate: 60,
    max_standard_flowrate: 115,
    torque_at_max_operating_differential_pressure: 6800,
    max_operating_differential_pressure: 380,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A700M GT',
    outer_diameter: 6.75,
    stages: 8.2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.42,
    min_standard_flowrate: 125,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 10500,
    max_operating_differential_pressure: 1650,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A700M HF',
    outer_diameter: 6.75,
    stages: 5.8,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.3,
    min_standard_flowrate: 180,
    max_standard_flowrate: 295,
    torque_at_max_operating_differential_pressure: 10500,
    max_operating_differential_pressure: 1150,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A700M GT',
    outer_diameter: 7,
    stages: 6.6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.29,
    min_standard_flowrate: 85,
    max_standard_flowrate: 175,
    torque_at_max_operating_differential_pressure: 12000,
    max_operating_differential_pressure: 1400,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A700M HF',
    outer_diameter: 7,
    stages: 4.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.21,
    min_standard_flowrate: 120,
    max_standard_flowrate: 205,
    torque_at_max_operating_differential_pressure: 12000,
    max_operating_differential_pressure: 920,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A77M SP',
    outer_diameter: 7.75,
    stages: 3.6,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.25,
    min_standard_flowrate: 75,
    max_standard_flowrate: 225,
    torque_at_max_operating_differential_pressure: 7500,
    max_operating_differential_pressure: 670,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A77M SP',
    outer_diameter: 7.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 45,
    max_standard_flowrate: 145,
    torque_at_max_operating_differential_pressure: 9900,
    max_operating_differential_pressure: 610,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A825M SP',
    outer_diameter: 8.25,
    stages: 1,
    number_rotor_lobes: 2,
    number_stator_lobes: 4,
    rpg: 0.72,
    min_standard_flowrate: 210,
    max_standard_flowrate: 430,
    torque_at_max_operating_differential_pressure: 2200,
    max_operating_differential_pressure: 510,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A825M SP',
    outer_diameter: 8.25,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 3.6,
    rpg: 0.25,
    min_standard_flowrate: 75,
    max_standard_flowrate: 225,
    torque_at_max_operating_differential_pressure: 7500,
    max_operating_differential_pressure: 670,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A825M XP',
    outer_diameter: 8.25,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 5.3,
    rpg: 0.25,
    min_standard_flowrate: 75,
    max_standard_flowrate: 225,
    torque_at_max_operating_differential_pressure: 10800,
    max_operating_differential_pressure: 1000,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A825M GT',
    outer_diameter: 8.25,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 8.2,
    rpg: 0.38,
    min_standard_flowrate: 115,
    max_standard_flowrate: 340,
    torque_at_max_operating_differential_pressure: 12500,
    max_operating_differential_pressure: 1620,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A825M SP',
    outer_diameter: 8.25,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 3,
    rpg: 0.16,
    min_standard_flowrate: 45,
    max_standard_flowrate: 145,
    torque_at_max_operating_differential_pressure: 9900,
    max_operating_differential_pressure: 610,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A825M XP',
    outer_diameter: 8.25,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 4,
    rpg: 0.16,
    min_standard_flowrate: 45,
    max_standard_flowrate: 145,
    torque_at_max_operating_differential_pressure: 13200,
    max_operating_differential_pressure: 820,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A962M SP',
    outer_diameter: 9.63,
    stages: 1,
    number_rotor_lobes: 2,
    number_stator_lobes: 5,
    rpg: 0.48,
    min_standard_flowrate: 190,
    max_standard_flowrate: 380,
    torque_at_max_operating_differential_pressure: 4200,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A962M HS',
    outer_diameter: 9.63,
    stages: 2,
    number_rotor_lobes: 3,
    number_stator_lobes: 9.2,
    rpg: 0.42,
    min_standard_flowrate: 250,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 12000,
    max_operating_differential_pressure: 1620,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A962M SP',
    outer_diameter: 9.63,
    stages: 3,
    number_rotor_lobes: 4,
    number_stator_lobes: 4.5,
    rpg: 0.22,
    min_standard_flowrate: 135,
    max_standard_flowrate: 265,
    torque_at_max_operating_differential_pressure: 10500,
    max_operating_differential_pressure: 760,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A962M XP',
    outer_diameter: 9.63,
    stages: 3,
    number_rotor_lobes: 4,
    number_stator_lobes: 6,
    rpg: 0.22,
    min_standard_flowrate: 135,
    max_standard_flowrate: 265,
    torque_at_max_operating_differential_pressure: 14000,
    max_operating_differential_pressure: 1025,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A962M GT',
    outer_diameter: 9.63,
    stages: 3,
    number_rotor_lobes: 4,
    number_stator_lobes: 8,
    rpg: 0.28,
    min_standard_flowrate: 167,
    max_standard_flowrate: 333,
    torque_at_max_operating_differential_pressure: 15000,
    max_operating_differential_pressure: 1450,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A962M SP',
    outer_diameter: 9.63,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 3,
    rpg: 0.11,
    min_standard_flowrate: 65,
    max_standard_flowrate: 135,
    torque_at_max_operating_differential_pressure: 13000,
    max_operating_differential_pressure: 530,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A962M XP',
    outer_diameter: 9.63,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 4,
    rpg: 0.11,
    min_standard_flowrate: 65,
    max_standard_flowrate: 135,
    torque_at_max_operating_differential_pressure: 18000,
    max_operating_differential_pressure: 710,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A962M GT',
    outer_diameter: 9.63,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 4.8,
    rpg: 0.11,
    min_standard_flowrate: 65,
    max_standard_flowrate: 135,
    torque_at_max_operating_differential_pressure: 24000,
    max_operating_differential_pressure: 1000,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A1125M SP',
    outer_diameter: 11.25,
    stages: 3,
    number_rotor_lobes: 4,
    number_stator_lobes: 3.6,
    rpg: 0.11,
    min_standard_flowrate: 115,
    max_standard_flowrate: 170,
    torque_at_max_operating_differential_pressure: 14900,
    max_operating_differential_pressure: 580,
  },
  {
    family: 'pdm',
    make: 'Schlumberger',
    model: 'A1125M GT',
    outer_diameter: 11.25,
    stages: 7,
    number_rotor_lobes: 8,
    number_stator_lobes: 4.8,
    rpg: 0.11,
    min_standard_flowrate: 65,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 24000,
    max_operating_differential_pressure: 1000,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 3.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.02,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2180,
    max_operating_differential_pressure: 790,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 3.6,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.07,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 2478,
    max_operating_differential_pressure: 821,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 5.4,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.07,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 3645,
    max_operating_differential_pressure: 1231,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 6.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.02,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3877,
    max_operating_differential_pressure: 1420,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 8.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4817,
    max_operating_differential_pressure: 1870,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 2.5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.45,
    min_standard_flowrate: 125,
    max_standard_flowrate: 325,
    torque_at_max_operating_differential_pressure: 3244,
    max_operating_differential_pressure: 570,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.438,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3289,
    max_operating_differential_pressure: 450,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.522,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2369,
    max_operating_differential_pressure: 500,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.3,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3905,
    max_operating_differential_pressure: 550,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 2.6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.263,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5295,
    max_operating_differential_pressure: 590,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.308,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 5188,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 3.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.368,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 5728,
    max_operating_differential_pressure: 830,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.521,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 4472,
    max_operating_differential_pressure: 860,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.56,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 7342,
    max_operating_differential_pressure: 1330,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.642,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 4475,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 3.4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.55,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 3850,
    max_operating_differential_pressure: 880,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 8.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1,
    min_standard_flowrate: 125,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 7508,
    max_operating_differential_pressure: 2910,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.82,
    min_standard_flowrate: 150,
    max_standard_flowrate: 360,
    torque_at_max_operating_differential_pressure: 4050,
    max_operating_differential_pressure: 1500,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 7,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.82,
    min_standard_flowrate: 150,
    max_standard_flowrate: 360,
    torque_at_max_operating_differential_pressure: 4725,
    max_operating_differential_pressure: 1750,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 8,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.8,
    min_standard_flowrate: 150,
    max_standard_flowrate: 360,
    torque_at_max_operating_differential_pressure: 5400,
    max_operating_differential_pressure: 2000,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 8.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.7,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 6717,
    max_operating_differential_pressure: 1850,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5,
    stages: 2,
    number_rotor_lobes: 9,
    number_stator_lobes: 1,
    rpg: 0.17,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 7613,
    max_operating_differential_pressure: 525,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 5.25,
    stages: 7.9,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 2.28,
    min_standard_flowrate: 100,
    max_standard_flowrate: 200,
    torque_at_max_operating_differential_pressure: 3470,
    max_operating_differential_pressure: 2570,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.35,
    min_standard_flowrate: 150,
    max_standard_flowrate: 525,
    torque_at_max_operating_differential_pressure: 9854,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.5,
    stages: 2.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.332,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 5005,
    max_operating_differential_pressure: 630,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.5,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.33,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 8615,
    max_operating_differential_pressure: 1080,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.5,
    stages: 4,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 1.05,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 1235,
    max_operating_differential_pressure: 475,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.5,
    stages: 2.7,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.22,
    min_standard_flowrate: 250,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 8100,
    max_operating_differential_pressure: 616,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.5,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.35,
    min_standard_flowrate: 200,
    max_standard_flowrate: 467,
    torque_at_max_operating_differential_pressure: 7400,
    max_operating_differential_pressure: 1000,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.5,
    stages: 4,
    number_rotor_lobes: 8,
    number_stator_lobes: 9,
    rpg: 0.17,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 14201,
    max_operating_differential_pressure: 955,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.5,
    stages: 3.5,
    number_rotor_lobes: 9,
    number_stator_lobes: 10,
    rpg: 0.15,
    min_standard_flowrate: 350,
    max_standard_flowrate: 550,
    torque_at_max_operating_differential_pressure: 15313,
    max_operating_differential_pressure: 875,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 2.2,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.292,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 4115,
    max_operating_differential_pressure: 495,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 3.1,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.497,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 2712,
    max_operating_differential_pressure: 470,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 4.8,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.5,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 5372,
    max_operating_differential_pressure: 945,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.497,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9117,
    max_operating_differential_pressure: 1580,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.292,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9394,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.28,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10925,
    max_operating_differential_pressure: 1140,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.154,
    min_standard_flowrate: 250,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 7200,
    max_operating_differential_pressure: 450,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 9996,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.28,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 6582,
    max_operating_differential_pressure: 684,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.283,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 6324,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.155,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10881,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 3.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.14,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 14060,
    max_operating_differential_pressure: 740,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 3.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.14,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 13461,
    max_operating_differential_pressure: 741,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10509,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.28,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 11014,
    max_operating_differential_pressure: 1140,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 5.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.242,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 13693,
    max_operating_differential_pressure: 1280,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 6.75,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 12555,
    max_operating_differential_pressure: 1350,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 7,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.5,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 12873,
    max_operating_differential_pressure: 2100,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 8,
    stages: 2.7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.239,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 4509,
    max_operating_differential_pressure: 410,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 8,
    stages: 5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.3,
    min_standard_flowrate: 500,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 6600,
    max_operating_differential_pressure: 800,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.17,
    min_standard_flowrate: 500,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 12546,
    max_operating_differential_pressure: 930,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 8,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 8721,
    max_operating_differential_pressure: 540,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 12693,
    max_operating_differential_pressure: 784,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 9.625,
    stages: 6,
    number_rotor_lobes: 3,
    number_stator_lobes: 4,
    rpg: 0.23,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 14316,
    max_operating_differential_pressure: 1125,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 9.625,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.11,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 12093,
    max_operating_differential_pressure: 487,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 9.625,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.13,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 23515,
    max_operating_differential_pressure: 1114,
  },
  {
    family: 'pdm',
    make: 'Cathedral',
    model: '',
    outer_diameter: 9.625,
    stages: 6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.16,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 17580,
    max_operating_differential_pressure: 1064,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 4.75,
    stages: 6.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.02,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3870,
    max_operating_differential_pressure: 1420,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 4.75,
    stages: 8.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 1870,
    max_operating_differential_pressure: 4810,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 4.75,
    stages: 2.6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.263,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5250,
    max_operating_differential_pressure: 590,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 4.75,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.521,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 4450,
    max_operating_differential_pressure: 860,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.62,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 3750,
    max_operating_differential_pressure: 840,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 6.5,
    stages: 7.8,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 1,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 4940,
    max_operating_differential_pressure: 1760,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 6.5,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.497,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9090,
    max_operating_differential_pressure: 1580,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 6.5,
    stages: 2.1,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.133,
    min_standard_flowrate: 250,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 9210,
    max_operating_differential_pressure: 470,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 6.5,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.155,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10800,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 6.5,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.283,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 6280,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 6.5,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10460,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 6.75,
    stages: 7.8,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 1,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 4940,
    max_operating_differential_pressure: 1760,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 6.75,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.497,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9090,
    max_operating_differential_pressure: 1580,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 6.75,
    stages: 2.1,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.133,
    min_standard_flowrate: 250,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 9210,
    max_operating_differential_pressure: 470,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.155,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10800,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.283,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 6280,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10450,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 8,
    stages: 3.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.089,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 21450,
    max_operating_differential_pressure: 770,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 14930,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Crescent',
    model: '',
    outer_diameter: 9.625,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.107,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 23770,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD168562.3',
    outer_diameter: 1.688,
    stages: 2.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 9.25,
    min_standard_flowrate: 20,
    max_standard_flowrate: 42,
    torque_at_max_operating_differential_pressure: 160,
    max_operating_differential_pressure: 580,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD168564.0',
    outer_diameter: 1.688,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 16.314,
    min_standard_flowrate: 20,
    max_standard_flowrate: 42,
    torque_at_max_operating_differential_pressure: 170,
    max_operating_differential_pressure: 1000,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD213564.0',
    outer_diameter: 2.125,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 9.574,
    min_standard_flowrate: 30,
    max_standard_flowrate: 65,
    torque_at_max_operating_differential_pressure: 270,
    max_operating_differential_pressure: 1000,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD213564.9',
    outer_diameter: 2.125,
    stages: 4.9,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 9.41,
    min_standard_flowrate: 30,
    max_standard_flowrate: 65,
    torque_at_max_operating_differential_pressure: 340,
    max_operating_differential_pressure: 1230,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD238564.0',
    outer_diameter: 2.375,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 7.175,
    min_standard_flowrate: 40,
    max_standard_flowrate: 80,
    torque_at_max_operating_differential_pressure: 360,
    max_operating_differential_pressure: 1000,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD287562.6',
    outer_diameter: 2.875,
    stages: 2.6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 2.3,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 660,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD287783.5',
    outer_diameter: 2.875,
    stages: 3.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 3.379,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 670,
    max_operating_differential_pressure: 880,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD287564.7',
    outer_diameter: 2.875,
    stages: 4.7,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 3.732,
    min_standard_flowrate: 60,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 820,
    max_operating_differential_pressure: 1180,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD287124.9',
    outer_diameter: 2.875,
    stages: 4.9,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 10.937,
    min_standard_flowrate: 30,
    max_standard_flowrate: 90,
    torque_at_max_operating_differential_pressure: 300,
    max_operating_differential_pressure: 1230,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 2.875,
    stages: 5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 2.907,
    min_standard_flowrate: 90,
    max_standard_flowrate: 170,
    torque_at_max_operating_differential_pressure: 1120,
    max_operating_differential_pressure: 1250,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD287567.0',
    outer_diameter: 2.875,
    stages: 7,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 5.74,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 850,
    max_operating_differential_pressure: 1750,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 3.125,
    stages: 2.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.488,
    min_standard_flowrate: 120,
    max_standard_flowrate: 210,
    torque_at_max_operating_differential_pressure: 1240,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD313783.0',
    outer_diameter: 3.125,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.69,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 1090,
    max_operating_differential_pressure: 750,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 3.125,
    stages: 3.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.488,
    min_standard_flowrate: 120,
    max_standard_flowrate: 230,
    torque_at_max_operating_differential_pressure: 1510,
    max_operating_differential_pressure: 830,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD338784.7',
    outer_diameter: 3.375,
    stages: 4.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.769,
    min_standard_flowrate: 120,
    max_standard_flowrate: 210,
    torque_at_max_operating_differential_pressure: 1520,
    max_operating_differential_pressure: 1060,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD350563.0',
    outer_diameter: 3.5,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 2.372,
    min_standard_flowrate: 30,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 750,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD350784.3',
    outer_diameter: 3.5,
    stages: 4.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.846,
    min_standard_flowrate: 30,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 1380,
    max_operating_differential_pressure: 970,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD375452.0',
    outer_diameter: 3.75,
    stages: 2,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.58,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 820,
    max_operating_differential_pressure: 450,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD375782.3',
    outer_diameter: 3.75,
    stages: 2.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.768,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 1670,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD375563.0',
    outer_diameter: 3.75,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 2.372,
    min_standard_flowrate: 30,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 750,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD375453.5',
    outer_diameter: 3.75,
    stages: 3.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.55,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 1430,
    max_operating_differential_pressure: 790,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD375563.8',
    outer_diameter: 3.75,
    stages: 3.8,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 2.275,
    min_standard_flowrate: 100,
    max_standard_flowrate: 200,
    torque_at_max_operating_differential_pressure: 700,
    max_operating_differential_pressure: 570,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD375564.2',
    outer_diameter: 3.75,
    stages: 4.2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.563,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 1050,
    max_operating_differential_pressure: 630,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD375786.7',
    outer_diameter: 3.75,
    stages: 6.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.613,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 2460,
    max_operating_differential_pressure: 1510,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD375238.0',
    outer_diameter: 3.75,
    stages: 8,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 5.8,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 580,
    max_operating_differential_pressure: 1200,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD375349.0',
    outer_diameter: 3.75,
    stages: 9,
    number_rotor_lobes: 3,
    number_stator_lobes: 4,
    rpg: 5.375,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 1010,
    max_operating_differential_pressure: 2030,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD3757810.1',
    outer_diameter: 3.75,
    stages: 10.1,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.95,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 2030,
    max_operating_differential_pressure: 1520,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475782.0',
    outer_diameter: 4.75,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.308,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3290,
    max_operating_differential_pressure: 450,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475782.1',
    outer_diameter: 4.75,
    stages: 2.1,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.294,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2520,
    max_operating_differential_pressure: 320,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475782.2',
    outer_diameter: 4.75,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.522,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2350,
    max_operating_differential_pressure: 500,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475782.2 SLOW',
    outer_diameter: 4.75,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.322,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2610,
    max_operating_differential_pressure: 330,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475782.6 ESX',
    outer_diameter: 4.75,
    stages: 2.6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.263,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5250,
    max_operating_differential_pressure: 590,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475782.9',
    outer_diameter: 4.75,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.308,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 5210,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475783.1',
    outer_diameter: 4.75,
    stages: 3.1,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.316,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5460,
    max_operating_differential_pressure: 700,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475453.5',
    outer_diameter: 4.75,
    stages: 3.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.02,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2170,
    max_operating_differential_pressure: 790,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475783.1',
    outer_diameter: 4.75,
    stages: 3.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.368,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 5750,
    max_operating_differential_pressure: 830,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475783.8',
    outer_diameter: 4.75,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.521,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 4450,
    max_operating_differential_pressure: 860,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475564.0',
    outer_diameter: 4.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.96,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1580,
    max_operating_differential_pressure: 600,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475784.5 SX',
    outer_diameter: 4.75,
    stages: 4.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.463,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5250,
    max_operating_differential_pressure: 1010,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475785.0',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.642,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 4460,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475456.0',
    outer_diameter: 4.75,
    stages: 6,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.02,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3690,
    max_operating_differential_pressure: 1350,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475566.0',
    outer_diameter: 4.75,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.839,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 2740,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475456.3',
    outer_diameter: 4.75,
    stages: 6.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.02,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3870,
    max_operating_differential_pressure: 1420,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475456.5 MX',
    outer_diameter: 4.75,
    stages: 6.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.933,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4120,
    max_operating_differential_pressure: 1460,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475566.7',
    outer_diameter: 4.75,
    stages: 6.7,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.946,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 4060,
    max_operating_differential_pressure: 1510,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475127.0',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 3.3,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1470,
    max_operating_differential_pressure: 1580,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475568.3',
    outer_diameter: 4.75,
    stages: 8.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4810,
    max_operating_differential_pressure: 1870,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD475238.5',
    outer_diameter: 4.75,
    stages: 8.5,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 1.913,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 2850,
    max_operating_differential_pressure: 1910,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD500568.3',
    outer_diameter: 5,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.522,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2350,
    max_operating_differential_pressure: 500,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD500568.3',
    outer_diameter: 5,
    stages: 2.6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.263,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5250,
    max_operating_differential_pressure: 590,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD500783.1',
    outer_diameter: 5,
    stages: 3.1,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.316,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5460,
    max_operating_differential_pressure: 700,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD500783.7',
    outer_diameter: 5,
    stages: 3.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.368,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 5750,
    max_operating_differential_pressure: 830,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD500783.8',
    outer_diameter: 5,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.521,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 4450,
    max_operating_differential_pressure: 860,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD500784.5 SX',
    outer_diameter: 5,
    stages: 4.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.463,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5250,
    max_operating_differential_pressure: 1010,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 8,
    number_stator_lobes: 9,
    rpg: 0.51,
    min_standard_flowrate: 200,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 6620,
    max_operating_differential_pressure: 1350,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 5,
    stages: 6.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.02,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3870,
    max_operating_differential_pressure: 1420,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 5,
    stages: 7,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.81,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 5000,
    max_operating_differential_pressure: 1580,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 5,
    stages: 8,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.81,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 5720,
    max_operating_differential_pressure: 1800,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD500788.2',
    outer_diameter: 5,
    stages: 8.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.7,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 6700,
    max_operating_differential_pressure: 1850,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD500568.3',
    outer_diameter: 5,
    stages: 8.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4810,
    max_operating_differential_pressure: 1870,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 5,
    stages: 8.4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.7,
    min_standard_flowrate: 200,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 7040,
    max_operating_differential_pressure: 1890,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 5,
    stages: 8.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.7,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 6860,
    max_operating_differential_pressure: 1890,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 5,
    stages: 10,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.87,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 6660,
    max_operating_differential_pressure: 2250,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD625782.5',
    outer_diameter: 6.25,
    stages: 2.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.171,
    min_standard_flowrate: 300,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 9340,
    max_operating_differential_pressure: 560,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD625782.8',
    outer_diameter: 6.25,
    stages: 2.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.332,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 5010,
    max_operating_differential_pressure: 630,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD625782.9 ESX',
    outer_diameter: 6.25,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 9600,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD625783.0 Slow',
    outer_diameter: 6.25,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.196,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 5690,
    max_operating_differential_pressure: 450,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD625783.3 ESX2',
    outer_diameter: 6.25,
    stages: 3.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 11550,
    max_operating_differential_pressure: 740,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 6.25,
    stages: 3.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.422,
    min_standard_flowrate: 250,
    max_standard_flowrate: 450,
    torque_at_max_operating_differential_pressure: 2800,
    max_operating_differential_pressure: 450,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD625783.5',
    outer_diameter: 6.25,
    stages: 3.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.208,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 9840,
    max_operating_differential_pressure: 790,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD625783.8 ESX3',
    outer_diameter: 6.25,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.158,
    min_standard_flowrate: 300,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 8980,
    max_operating_differential_pressure: 570,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD625784.8',
    outer_diameter: 6.25,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.33,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 8620,
    max_operating_differential_pressure: 1080,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD625675.0',
    outer_diameter: 6.25,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.34,
    min_standard_flowrate: 300,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 7900,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD625786.7 SX3',
    outer_diameter: 6.25,
    stages: 6.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.278,
    min_standard_flowrate: 300,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 9040,
    max_operating_differential_pressure: 1010,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD625457.5',
    outer_diameter: 6.25,
    stages: 7.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.659,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 7150,
    max_operating_differential_pressure: 1690,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650782.8',
    outer_diameter: 6.5,
    stages: 2.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.332,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 5010,
    max_operating_differential_pressure: 630,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650782.9 ESX',
    outer_diameter: 6.5,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 9600,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650783.3',
    outer_diameter: 6.5,
    stages: 3.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 11550,
    max_operating_differential_pressure: 740,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650783.5',
    outer_diameter: 6.5,
    stages: 3.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.0208,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 9840,
    max_operating_differential_pressure: 790,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650783.8 ESX3',
    outer_diameter: 6.5,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.158,
    min_standard_flowrate: 300,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 8980,
    max_operating_differential_pressure: 570,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD6509103.8',
    outer_diameter: 6.5,
    stages: 3.8,
    number_rotor_lobes: 9,
    number_stator_lobes: 10,
    rpg: 0.15,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9230,
    max_operating_differential_pressure: 570,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650124.0',
    outer_diameter: 6.5,
    stages: 4,
    number_rotor_lobes: 1,
    number_stator_lobes: 2,
    rpg: 1.186,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 1370,
    max_operating_differential_pressure: 600,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650784.8',
    outer_diameter: 6.5,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.33,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 8620,
    max_operating_differential_pressure: 1080,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650785.3',
    outer_diameter: 6.5,
    stages: 5.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.278,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10910,
    max_operating_differential_pressure: 1190,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650457.0',
    outer_diameter: 6.5,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.497,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9090,
    max_operating_differential_pressure: 1580,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650237.8',
    outer_diameter: 6.5,
    stages: 7.8,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 1,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 4940,
    max_operating_differential_pressure: 1760,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650457.5',
    outer_diameter: 6.5,
    stages: 7.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.659,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 7150,
    max_operating_differential_pressure: 1690,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650675.0',
    outer_diameter: 6.5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.292,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9350,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650785.0',
    outer_diameter: 6.5,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10460,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650786.0',
    outer_diameter: 6.5,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 12560,
    max_operating_differential_pressure: 1350,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD650894.0',
    outer_diameter: 6.5,
    stages: 4,
    number_rotor_lobes: 8,
    number_stator_lobes: 9,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 7950,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675782.1 ESX',
    outer_diameter: 6.535,
    stages: 2.1,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.133,
    min_standard_flowrate: 250,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 9210,
    max_operating_differential_pressure: 470,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675782.0',
    outer_diameter: 6.75,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.154,
    min_standard_flowrate: 250,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 7200,
    max_operating_differential_pressure: 450,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD6759102.0',
    outer_diameter: 6.75,
    stages: 2,
    number_rotor_lobes: 9,
    number_stator_lobes: 10,
    rpg: 0.278,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 3820,
    max_operating_differential_pressure: 450,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675782.9 ESX',
    outer_diameter: 6.75,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 9600,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675783.0 Slow',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.155,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10800,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675783.0',
    outer_diameter: 6.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.283,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 6280,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675453.1',
    outer_diameter: 6.75,
    stages: 3.1,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.497,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 2680,
    max_operating_differential_pressure: 470,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675783.3',
    outer_diameter: 6.75,
    stages: 3.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.14,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 14110,
    max_operating_differential_pressure: 740,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD6759104.0',
    outer_diameter: 6.75,
    stages: 4,
    number_rotor_lobes: 9,
    number_stator_lobes: 10,
    rpg: 0.27,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 7610,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675456.0 MX',
    outer_diameter: 6.75,
    stages: 6,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.491,
    min_standard_flowrate: 300,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 8520,
    max_operating_differential_pressure: 1350,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675564.0',
    outer_diameter: 6.75,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.378,
    min_standard_flowrate: 250,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 4200,
    max_operating_differential_pressure: 600,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675784.1 ESX3',
    outer_diameter: 6.75,
    stages: 4.1,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.15,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10500,
    max_operating_differential_pressure: 620,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675675.0',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.292,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9350,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675785.0',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10460,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675786.4',
    outer_diameter: 6.75,
    stages: 6.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 13390,
    max_operating_differential_pressure: 1440,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675457.0',
    outer_diameter: 6.75,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.497,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9090,
    max_operating_differential_pressure: 1580,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 6.75,
    stages: 8.1,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.39,
    min_standard_flowrate: 300,
    max_standard_flowrate: 700,
    torque_at_max_operating_differential_pressure: 12040,
    max_operating_differential_pressure: 1820,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 6.75,
    stages: 2.1,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.133,
    min_standard_flowrate: 250,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 9210,
    max_operating_differential_pressure: 470,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675782.9',
    outer_diameter: 6.75,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 10030,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675783.5 ESX2',
    outer_diameter: 6.75,
    stages: 3.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.15,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 13500,
    max_operating_differential_pressure: 790,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675785.7 SX2',
    outer_diameter: 6.75,
    stages: 5.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.242,
    min_standard_flowrate: 300,
    max_standard_flowrate: 650,
    torque_at_max_operating_differential_pressure: 13720,
    max_operating_differential_pressure: 1280,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675786.0',
    outer_diameter: 6.75,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 12560,
    max_operating_differential_pressure: 1350,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675456.5 MX2',
    outer_diameter: 6.75,
    stages: 6.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.35,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9320,
    max_operating_differential_pressure: 980,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675786.7 SX3',
    outer_diameter: 6.75,
    stages: 6.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.242,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10750,
    max_operating_differential_pressure: 1010,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD675237.8',
    outer_diameter: 6.75,
    stages: 7.8,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 1,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 4940,
    max_operating_differential_pressure: 1760,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 6.75,
    stages: 8.1,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.41,
    min_standard_flowrate: 400,
    max_standard_flowrate: 800,
    torque_at_max_operating_differential_pressure: 11590,
    max_operating_differential_pressure: 1820,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 7,
    stages: 4.6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.15,
    min_standard_flowrate: 300,
    max_standard_flowrate: 700,
    torque_at_max_operating_differential_pressure: 17770,
    max_operating_differential_pressure: 1040,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD700785.0',
    outer_diameter: 7,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10460,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD700786.8',
    outer_diameter: 7,
    stages: 6.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.304,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 14630,
    max_operating_differential_pressure: 1530,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 7,
    stages: 8.1,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.41,
    min_standard_flowrate: 500,
    max_standard_flowrate: 725,
    torque_at_max_operating_differential_pressure: 11590,
    max_operating_differential_pressure: 1820,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD700568.2',
    outer_diameter: 7,
    stages: 8.2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.426,
    min_standard_flowrate: 300,
    max_standard_flowrate: 700,
    torque_at_max_operating_differential_pressure: 11270,
    max_operating_differential_pressure: 1850,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 7,
    stages: 10.8,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.45,
    min_standard_flowrate: 300,
    max_standard_flowrate: 750,
    torque_at_max_operating_differential_pressure: 14070,
    max_operating_differential_pressure: 2430,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 7,
    stages: 12.1,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.4,
    min_standard_flowrate: 350,
    max_standard_flowrate: 750,
    torque_at_max_operating_differential_pressure: 17530,
    max_operating_differential_pressure: 2720,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 7,
    stages: 8.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.26,
    min_standard_flowrate: 400,
    max_standard_flowrate: 750,
    torque_at_max_operating_differential_pressure: 18710,
    max_operating_differential_pressure: 1910,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 7.25,
    stages: 4.6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.15,
    min_standard_flowrate: 300,
    max_standard_flowrate: 700,
    torque_at_max_operating_differential_pressure: 17770,
    max_operating_differential_pressure: 1040,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 7.25,
    stages: 12.1,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.4,
    min_standard_flowrate: 350,
    max_standard_flowrate: 750,
    torque_at_max_operating_differential_pressure: 17530,
    max_operating_differential_pressure: 2720,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD775783.0',
    outer_diameter: 7.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 11200,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD7759103.0 ESX',
    outer_diameter: 7.75,
    stages: 3,
    number_rotor_lobes: 9,
    number_stator_lobes: 10,
    rpg: 0.112,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 16580,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD775784.0',
    outer_diameter: 7.75,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 14930,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD775455.3',
    outer_diameter: 7.75,
    stages: 5.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.253,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 13310,
    max_operating_differential_pressure: 1190,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD775456.0 MX2',
    outer_diameter: 7.75,
    stages: 6,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.246,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 15300,
    max_operating_differential_pressure: 1350,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD800782.5',
    outer_diameter: 8,
    stages: 2.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.08,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 11620,
    max_operating_differential_pressure: 380,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD800452.7',
    outer_diameter: 8,
    stages: 2.7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.239,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 6680,
    max_operating_differential_pressure: 610,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD800783.0',
    outer_diameter: 8,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 11200,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD8009103.0 ESX',
    outer_diameter: 8,
    stages: 3,
    number_rotor_lobes: 9,
    number_stator_lobes: 10,
    rpg: 0.112,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 16580,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD800783.4 ESX3',
    outer_diameter: 8,
    stages: 3.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.089,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 21450,
    max_operating_differential_pressure: 770,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD800784.0',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 14930,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.18,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 13240,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 14930,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD800456.0 MX2',
    outer_diameter: 8,
    stages: 5.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.253,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 13310,
    max_operating_differential_pressure: 1190,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 8,
    stages: 5.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 22020,
    max_operating_differential_pressure: 1330,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD800456.0 MX2',
    outer_diameter: 8,
    stages: 6,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.246,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 15300,
    max_operating_differential_pressure: 1350,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD800566.0 MX',
    outer_diameter: 8,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.248,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 10200,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 8.25,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 14930,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 8.25,
    stages: 5.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.253,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 13310,
    max_operating_differential_pressure: 1190,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 8.25,
    stages: 5.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 22020,
    max_operating_differential_pressure: 1330,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 8.25,
    stages: 7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 1000,
    torque_at_max_operating_differential_pressure: 24130,
    max_operating_differential_pressure: 1580,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD962562.5',
    outer_diameter: 9.625,
    stages: 2.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.117,
    min_standard_flowrate: 800,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 7800,
    max_operating_differential_pressure: 380,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD962563.0',
    outer_diameter: 9.625,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.113,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 10940,
    max_operating_differential_pressure: 450,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 9.625,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.108,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 19240,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD962783.9 ESX3',
    outer_diameter: 9.625,
    stages: 3.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.068,
    min_standard_flowrate: 700,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 33750,
    max_operating_differential_pressure: 880,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD962564.0',
    outer_diameter: 9.625,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.108,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 19240,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD962784.8',
    outer_diameter: 9.625,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.11,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 24050,
    max_operating_differential_pressure: 1080,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD962565.0 MX',
    outer_diameter: 9.625,
    stages: 5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.138,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 24170,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD962675.0',
    outer_diameter: 9.625,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.127,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 22840,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 9.625,
    stages: 5.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.132,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 16470,
    max_operating_differential_pressure: 860,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD962346.0',
    outer_diameter: 9.625,
    stages: 6,
    number_rotor_lobes: 3,
    number_stator_lobes: 4,
    rpg: 0.221,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 17210,
    max_operating_differential_pressure: 1350,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD962786.5 SX3',
    outer_diameter: 9.625,
    stages: 6.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.113,
    min_standard_flowrate: 700,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 22500,
    max_operating_differential_pressure: 980,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD1125564.6',
    outer_diameter: 11.25,
    stages: 4.6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.089,
    min_standard_flowrate: 800,
    max_standard_flowrate: 1800,
    torque_at_max_operating_differential_pressure: 32700,
    max_operating_differential_pressure: 1040,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD1125784.8',
    outer_diameter: 11.25,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.114,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 24040,
    max_operating_differential_pressure: 1080,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 11.25,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.127,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 22840,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD1150783.9',
    outer_diameter: 11.5,
    stages: 3.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.071,
    min_standard_flowrate: 1000,
    max_standard_flowrate: 1800,
    torque_at_max_operating_differential_pressure: 21020,
    max_operating_differential_pressure: 590,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD1150564.6',
    outer_diameter: 11.5,
    stages: 4.6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.089,
    min_standard_flowrate: 1000,
    max_standard_flowrate: 1800,
    torque_at_max_operating_differential_pressure: 32700,
    max_operating_differential_pressure: 1040,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: 'DD1150565.0',
    outer_diameter: 11.5,
    stages: 5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.135,
    min_standard_flowrate: 700,
    max_standard_flowrate: 1300,
    torque_at_max_operating_differential_pressure: 21640,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Dyna-Drill',
    model: '',
    outer_diameter: 11.75,
    stages: 7.2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.128,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 34800,
    max_operating_differential_pressure: 1620,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 2.875,
    stages: 7,
    number_rotor_lobes: 2,
    number_stator_lobes: 3,
    rpg: 11.22,
    min_standard_flowrate: 40,
    max_standard_flowrate: 70,
    torque_at_max_operating_differential_pressure: 175,
    max_operating_differential_pressure: 970,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 2.875,
    stages: 3.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 4.11,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 1420,
    max_operating_differential_pressure: 1300,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 2.875,
    stages: 4.7,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 3.32,
    min_standard_flowrate: 60,
    max_standard_flowrate: 125,
    torque_at_max_operating_differential_pressure: 870,
    max_operating_differential_pressure: 1060,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 3.125,
    stages: 3.2,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 2.5,
    min_standard_flowrate: 80,
    max_standard_flowrate: 140,
    torque_at_max_operating_differential_pressure: 976,
    max_operating_differential_pressure: 1000,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 3.125,
    stages: 3.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 5.42,
    min_standard_flowrate: 20,
    max_standard_flowrate: 80,
    torque_at_max_operating_differential_pressure: 250,
    max_operating_differential_pressure: 490,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 3.125,
    stages: 3.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 2.25,
    min_standard_flowrate: 100,
    max_standard_flowrate: 210,
    torque_at_max_operating_differential_pressure: 1110,
    max_operating_differential_pressure: 790,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 3.125,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.69,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 732,
    max_operating_differential_pressure: 600,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 3.125,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 3.71,
    min_standard_flowrate: 70,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 690,
    max_operating_differential_pressure: 1125,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 3.125,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 3.71,
    min_standard_flowrate: 70,
    max_standard_flowrate: 110,
    torque_at_max_operating_differential_pressure: 437,
    max_operating_differential_pressure: 750,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 3.75,
    stages: 1.7,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 1,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 986,
    max_operating_differential_pressure: 432,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 3.75,
    stages: 6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.69,
    min_standard_flowrate: 80,
    max_standard_flowrate: 200,
    torque_at_max_operating_differential_pressure: 1315,
    max_operating_differential_pressure: 580,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 3.75,
    stages: 2.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.77,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 1670,
    max_operating_differential_pressure: 520,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 3.75,
    stages: 2.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.77,
    min_standard_flowrate: 80,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 1110,
    max_operating_differential_pressure: 350,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 4.75,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.52,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 4965,
    max_operating_differential_pressure: 1085,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.03,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1656,
    max_operating_differential_pressure: 621,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.03,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1104,
    max_operating_differential_pressure: 414,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 6.7,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.63,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 6330,
    max_operating_differential_pressure: 1580,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 8.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4980,
    max_operating_differential_pressure: 1960,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.84,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4233,
    max_operating_differential_pressure: 1505,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 8,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.84,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 5897,
    max_operating_differential_pressure: 2065,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 8.8,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.66,
    min_standard_flowrate: 150,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 7660,
    max_operating_differential_pressure: 2070,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.3,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2781,
    max_operating_differential_pressure: 374,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 2.6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.27,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 3500,
    max_operating_differential_pressure: 305,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 2.6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.26,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5250,
    max_operating_differential_pressure: 590,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 3.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.36,
    min_standard_flowrate: 180,
    max_standard_flowrate: 330,
    torque_at_max_operating_differential_pressure: 2960,
    max_operating_differential_pressure: 870,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.52,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 4965,
    max_operating_differential_pressure: 1085,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 4.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.46,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5250,
    max_operating_differential_pressure: 1010,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.62,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4670,
    max_operating_differential_pressure: 1180,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 8,
    number_stator_lobes: 9,
    rpg: 0.51,
    min_standard_flowrate: 150,
    max_standard_flowrate: 280,
    torque_at_max_operating_differential_pressure: 6910,
    max_operating_differential_pressure: 1410,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.5,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.5,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 5565,
    max_operating_differential_pressure: 1260,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.5,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.49,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 8820,
    max_operating_differential_pressure: 1650,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.31,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9762,
    max_operating_differential_pressure: 1260,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.5,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.15,
    min_standard_flowrate: 250,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 7200,
    max_operating_differential_pressure: 450,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.5,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 12735,
    max_operating_differential_pressure: 875,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.5,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.28,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 6280,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.5,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10800,
    max_operating_differential_pressure: 680,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.5,
    stages: 3.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 15610,
    max_operating_differential_pressure: 945,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.5,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.33,
    min_standard_flowrate: 200,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 9948,
    max_operating_differential_pressure: 1365,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.5,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.28,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 12813,
    max_operating_differential_pressure: 1505,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.5,
    stages: 5.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.24,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 15922,
    max_operating_differential_pressure: 1645,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.75,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.49,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 8820,
    max_operating_differential_pressure: 1650,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.75,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.5,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 5565,
    max_operating_differential_pressure: 1260,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.31,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9762,
    max_operating_differential_pressure: 1260,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.75,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 12735,
    max_operating_differential_pressure: 875,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 6.75,
    stages: 5.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.24,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 15922,
    max_operating_differential_pressure: 1645,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 7,
    stages: 5.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.3,
    min_standard_flowrate: 200,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 15600,
    max_operating_differential_pressure: 1550,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 7,
    stages: 5.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.23,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 14200,
    max_operating_differential_pressure: 1340,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 7,
    stages: 8.1,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.41,
    min_standard_flowrate: 500,
    max_standard_flowrate: 700,
    torque_at_max_operating_differential_pressure: 11590,
    max_operating_differential_pressure: 1820,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 7,
    stages: 6.5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.23,
    min_standard_flowrate: 400,
    max_standard_flowrate: 750,
    torque_at_max_operating_differential_pressure: 16690,
    max_operating_differential_pressure: 1530,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 7,
    stages: 8.4,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.3,
    min_standard_flowrate: 350,
    max_standard_flowrate: 750,
    torque_at_max_operating_differential_pressure: 16550,
    max_operating_differential_pressure: 1980,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 7,
    stages: 11.4,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.42,
    min_standard_flowrate: 350,
    max_standard_flowrate: 750,
    torque_at_max_operating_differential_pressure: 16350,
    max_operating_differential_pressure: 2680,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 7,
    stages: 8.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.26,
    min_standard_flowrate: 500,
    max_standard_flowrate: 750,
    torque_at_max_operating_differential_pressure: 18710,
    max_operating_differential_pressure: 1910,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 7,
    stages: 8,
    number_rotor_lobes: 9,
    number_stator_lobes: 10,
    rpg: 0.27,
    min_standard_flowrate: 400,
    max_standard_flowrate: 700,
    torque_at_max_operating_differential_pressure: 18155,
    max_operating_differential_pressure: 2000,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 8,
    stages: 5.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.24,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 13620,
    max_operating_differential_pressure: 1250,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 8,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.19,
    min_standard_flowrate: 500,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 6123,
    max_operating_differential_pressure: 431,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 8,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.19,
    min_standard_flowrate: 500,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 4082,
    max_operating_differential_pressure: 287,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.17,
    min_standard_flowrate: 500,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 13820,
    max_operating_differential_pressure: 940,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.17,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 8820,
    max_operating_differential_pressure: 600,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 8,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.17,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 17076,
    max_operating_differential_pressure: 1260,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 8,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.17,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 11152,
    max_operating_differential_pressure: 840,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 8,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.29,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 7100,
    max_operating_differential_pressure: 374,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 8,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 7928,
    max_operating_differential_pressure: 491,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 8,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 5285,
    max_operating_differential_pressure: 327,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 8,
    stages: 3.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.09,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 22530,
    max_operating_differential_pressure: 800,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 14830,
    max_operating_differential_pressure: 940,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.18,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 9470,
    max_operating_differential_pressure: 600,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 8,
    stages: 5.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 21870,
    max_operating_differential_pressure: 1390,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 9.625,
    stages: 5.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 21870,
    max_operating_differential_pressure: 1390,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 9.625,
    stages: 3.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.09,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 22530,
    max_operating_differential_pressure: 800,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 9.625,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 11140,
    max_operating_differential_pressure: 710,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 9.625,
    stages: 4,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.17,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 13820,
    max_operating_differential_pressure: 940,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 9.625,
    stages: 6,
    number_rotor_lobes: 3,
    number_stator_lobes: 4,
    rpg: 0.22,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 11480,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 9.625,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.13,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 14011,
    max_operating_differential_pressure: 828,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 9.625,
    stages: 6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.13,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 27120,
    max_operating_differential_pressure: 1560,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 9.625,
    stages: 6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.13,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 17697,
    max_operating_differential_pressure: 1040,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 9.625,
    stages: 5.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.13,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 25920,
    max_operating_differential_pressure: 1340,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 11.25,
    stages: 4.6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.09,
    min_standard_flowrate: 800,
    max_standard_flowrate: 1800,
    torque_at_max_operating_differential_pressure: 32700,
    max_operating_differential_pressure: 1040,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 11.25,
    stages: 4.6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.09,
    min_standard_flowrate: 800,
    max_standard_flowrate: 1800,
    torque_at_max_operating_differential_pressure: 21800,
    max_operating_differential_pressure: 690,
  },
  {
    family: 'pdm',
    make: 'Dynomax',
    model: '',
    outer_diameter: 11.25,
    stages: 5.5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.09,
    min_standard_flowrate: 900,
    max_standard_flowrate: 1800,
    torque_at_max_operating_differential_pressure: 37640,
    max_operating_differential_pressure: 1260,
  },
  {
    family: 'pdm',
    make: 'GyroData',
    model: '',
    outer_diameter: 4.75,
    stages: 8.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4810,
    max_operating_differential_pressure: 1870,
  },
  {
    family: 'pdm',
    make: 'GyroData',
    model: '',
    outer_diameter: 4.75,
    stages: 2.6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.26,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5250,
    max_operating_differential_pressure: 590,
  },
  {
    family: 'pdm',
    make: 'GyroData',
    model: '',
    outer_diameter: 4.75,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.52,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 4450,
    max_operating_differential_pressure: 860,
  },
  {
    family: 'pdm',
    make: 'GyroData',
    model: '',
    outer_diameter: 5,
    stages: 8,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.81,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 5720,
    max_operating_differential_pressure: 1800,
  },
  {
    family: 'pdm',
    make: 'GyroData',
    model: '',
    outer_diameter: 6.5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.29,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9350,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'GyroData',
    model: '',
    outer_diameter: 6.5,
    stages: 3.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.14,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 14110,
    max_operating_differential_pressure: 740,
  },
  {
    family: 'pdm',
    make: 'GyroData',
    model: '',
    outer_diameter: 6.75,
    stages: 7,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.5,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9090,
    max_operating_differential_pressure: 1580,
  },
  {
    family: 'pdm',
    make: 'GyroData',
    model: '',
    outer_diameter: 6.75,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.29,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9350,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'GyroData',
    model: '',
    outer_diameter: 6.75,
    stages: 3.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.14,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 14110,
    max_operating_differential_pressure: 740,
  },
  {
    family: 'pdm',
    make: 'GyroData',
    model: '',
    outer_diameter: 6.75,
    stages: 5.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.24,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 13720,
    max_operating_differential_pressure: 1280,
  },
  {
    family: 'pdm',
    make: 'GyroData',
    model: '',
    outer_diameter: 7,
    stages: 6.5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.23,
    min_standard_flowrate: 400,
    max_standard_flowrate: 750,
    torque_at_max_operating_differential_pressure: 16690,
    max_operating_differential_pressure: 1530,
  },
  {
    family: 'pdm',
    make: 'GyroData',
    model: '',
    outer_diameter: 8,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 14930,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '4-3/4” Motor 4/5 Lobe 6.0 Stage',
    outer_diameter: 4.75,
    stages: 1.02,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.02,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3690,
    max_operating_differential_pressure: 590,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '4-3/4” Motor 5/6 Lobe 8.3 Stage',
    outer_diameter: 4.75,
    stages: 1,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4810,
    max_operating_differential_pressure: 860,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '4-3/4” Motor 7/8 Lobe 2.6 Stage',
    outer_diameter: 4.75,
    stages: 0.263,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.263,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5250,
    max_operating_differential_pressure: 2030,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '4-3/4” Motor 7/8 Lobe 3.8 Stage',
    outer_diameter: 4.75,
    stages: 0.521,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.521,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 4450,
    max_operating_differential_pressure: 1870,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '5” Motor 6/7 Lobe 8.0 Stage',
    outer_diameter: 5,
    stages: 0.81,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.81,
    min_standard_flowrate: 100,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 5720,
    max_operating_differential_pressure: 1800,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '5-1/8” Motor 6/7 Lobe 8.0 Stage',
    outer_diameter: 5.125,
    stages: 0.79,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.79,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 6110,
    max_operating_differential_pressure: 1880,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '6-3/4” Motor 4/5 Lobe 7.0 Stage',
    outer_diameter: 6.75,
    stages: 0.497,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.497,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9090,
    max_operating_differential_pressure: 1580,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '6-3/4” Motor 7/8 Lobe 3.5 Stage',
    outer_diameter: 6.75,
    stages: 0.15,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.15,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 13500,
    max_operating_differential_pressure: 790,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '6-3/4” Motor 7/8 Lobe 5.0 Stage',
    outer_diameter: 6.75,
    stages: 0.288,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.288,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10460,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '6-3/4” Motor 7/8 Lobe 5.7 Stage',
    outer_diameter: 6.75,
    stages: 0.242,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.242,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 13720,
    max_operating_differential_pressure: 1280,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '7” Motor 5/6 Lobe 8.2 Stage',
    outer_diameter: 7,
    stages: 0.426,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.426,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 11270,
    max_operating_differential_pressure: 1850,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '7-1/8” Motor 4/5 Lobe 7.0 Stage',
    outer_diameter: 7.125,
    stages: 0.494,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.494,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 8820,
    max_operating_differential_pressure: 1650,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '7-1/8” Motor 7/8 Lobe 5.0 Stage',
    outer_diameter: 7.125,
    stages: 0.27,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.27,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10650,
    max_operating_differential_pressure: 1180,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '7-1/8” Motor 7/8 Lobe 5.7 Stage',
    outer_diameter: 7.125,
    stages: 0.23,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.23,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 14200,
    max_operating_differential_pressure: 1340,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '7-3/4” Motor 4/5 Lobe 6.0 Stage',
    outer_diameter: 7.75,
    stages: 0.246,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.246,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 15300,
    max_operating_differential_pressure: 1350,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '7-3/4” Motor 7/8 Lobe 4.0 Stage',
    outer_diameter: 7.75,
    stages: 0.166,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 14930,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '8-1/2” Motor 7/8 Lobe 3.4 Stage',
    outer_diameter: 8.5,
    stages: 3.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.087,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 22530,
    max_operating_differential_pressure: 800,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '8-1/2” Motor 7/8 Lobe 4.0 Stage',
    outer_diameter: 8.5,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.155,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 14830,
    max_operating_differential_pressure: 940,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '8-1/2” Motor 7/8 Lobe 5.9 Stage',
    outer_diameter: 8.5,
    stages: 5.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.166,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 22020,
    max_operating_differential_pressure: 1330,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '9-5/8” Motor 5/6 Lobe 4.0 Stage',
    outer_diameter: 9.625,
    stages: 0.122,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.122,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 19240,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '9-5/8” Motor 7/8 Lobe 3.9 Stage',
    outer_diameter: 9.625,
    stages: 0.068,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.068,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 33750,
    max_operating_differential_pressure: 880,
  },
  {
    family: 'pdm',
    make: 'Rival',
    model: '9-5/8” Motor 7/8 Lobe 4.8 Stage',
    outer_diameter: 9.625,
    stages: 0.144,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.144,
    min_standard_flowrate: '',
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 24050,
    max_operating_differential_pressure: 1080,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '2 7/8 5:6 3.5 (250)',
    outer_diameter: 2.88,
    stages: 3.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 3.61,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 631,
    max_operating_differential_pressure: 875,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '2 7/8 5:6 3.5 (175)',
    outer_diameter: 2.88,
    stages: 3.5,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 3.61,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 631,
    max_operating_differential_pressure: 613,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '2 7/8 7:8 2.0 (250)',
    outer_diameter: 2.88,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.78,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 604,
    max_operating_differential_pressure: 500,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '2 7/8 7:8 2.0 (175)',
    outer_diameter: 2.88,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.78,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 423,
    max_operating_differential_pressure: 350,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '2 7/8 7:8 3.6 (175)',
    outer_diameter: 2.88,
    stages: 3.6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 3.24,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 506,
    max_operating_differential_pressure: 630,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '2 7/8 7:8 3.6 (250)',
    outer_diameter: 2.88,
    stages: 3.6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 3.24,
    min_standard_flowrate: 60,
    max_standard_flowrate: 120,
    torque_at_max_operating_differential_pressure: 724,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '2 7/8 7:8 3.7 (175)',
    outer_diameter: 2.88,
    stages: 3.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 2.3,
    min_standard_flowrate: 60,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 733,
    max_operating_differential_pressure: 648,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '2 7/8 7:8 3.7 (250)',
    outer_diameter: 2.88,
    stages: 3.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 2.3,
    min_standard_flowrate: 60,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 1047,
    max_operating_differential_pressure: 925,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '3 1/8 (2 7/8) 7:8 3.7 (175)',
    outer_diameter: 3.13,
    stages: 3.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 2.3,
    min_standard_flowrate: 60,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 733,
    max_operating_differential_pressure: 648,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '3 1/8 (2 7/8) 7:8 3.7 (250)',
    outer_diameter: 3.13,
    stages: 3.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 2.3,
    min_standard_flowrate: 60,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 1045,
    max_operating_differential_pressure: 925,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '3 1/8 5:6 1.3 (250)',
    outer_diameter: 3.13,
    stages: 1.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 3.13,
    min_standard_flowrate: 130,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 253,
    max_operating_differential_pressure: 325,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '3 1/8 5:6 1.3 (175)',
    outer_diameter: 3.13,
    stages: 1.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 3.13,
    min_standard_flowrate: 130,
    max_standard_flowrate: 160,
    torque_at_max_operating_differential_pressure: 177,
    max_operating_differential_pressure: 228,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '3 1/2 7:8 3.8 (250)',
    outer_diameter: 3.5,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.57,
    min_standard_flowrate: 75,
    max_standard_flowrate: 150,
    torque_at_max_operating_differential_pressure: 1576,
    max_operating_differential_pressure: 950,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '3 1/2 7:8 3.8 (175)',
    outer_diameter: 3.5,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.57,
    min_standard_flowrate: 75,
    max_standard_flowrate: 150,
    torque_at_max_operating_differential_pressure: 1103,
    max_operating_differential_pressure: 665,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 1/8 7:8 3.2 (175)',
    outer_diameter: 4.13,
    stages: 3.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.79,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1752,
    max_operating_differential_pressure: 560,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 1/8 7:8 3.2 (250)',
    outer_diameter: 4.13,
    stages: 3.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.79,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2503,
    max_operating_differential_pressure: 800,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 1/8 7:8 5.4 (250)',
    outer_diameter: 4.13,
    stages: 5.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.32,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2518,
    max_operating_differential_pressure: 1350,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 1/8 7:8 5.4 (175)',
    outer_diameter: 4.13,
    stages: 5.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.32,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 1763,
    max_operating_differential_pressure: 945,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 4:5 6.0 (175)',
    outer_diameter: 4.75,
    stages: 6,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.01,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 2730,
    max_operating_differential_pressure: 1050,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 4:5 6.0 (250)',
    outer_diameter: 4.75,
    stages: 6,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.01,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 3900,
    max_operating_differential_pressure: 1500,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 4:5 6.3 (175)',
    outer_diameter: 4.75,
    stages: 6.3,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.01,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 2866,
    max_operating_differential_pressure: 1103,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 4:5 6.3 (250)',
    outer_diameter: 4.75,
    stages: 6,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 1.01,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4095,
    max_operating_differential_pressure: 1575,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 5:6 6.0 (175)',
    outer_diameter: 4.75,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.85,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 3214,
    max_operating_differential_pressure: 1050,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 5:6 6.0 (250)',
    outer_diameter: 4.75,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.85,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 4590,
    max_operating_differential_pressure: 1500,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 5:6 8.3 (175)',
    outer_diameter: 4.75,
    stages: 8.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.98,
    min_standard_flowrate: 150,
    max_standard_flowrate: 325,
    torque_at_max_operating_differential_pressure: 3935,
    max_operating_differential_pressure: 1453,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 5:6 8.3 (250)',
    outer_diameter: 4.75,
    stages: 8.3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.98,
    min_standard_flowrate: 150,
    max_standard_flowrate: 325,
    torque_at_max_operating_differential_pressure: 5621,
    max_operating_differential_pressure: 2075,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 6:7 7.0 (175)',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.82,
    min_standard_flowrate: 150,
    max_standard_flowrate: 360,
    torque_at_max_operating_differential_pressure: 3798,
    max_operating_differential_pressure: 1225,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 6:7 7.0 (250)',
    outer_diameter: 4.75,
    stages: 7,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.82,
    min_standard_flowrate: 150,
    max_standard_flowrate: 360,
    torque_at_max_operating_differential_pressure: 5425,
    max_operating_differential_pressure: 1750,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 2.0 Air (250)',
    outer_diameter: 4.75,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.3,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3571,
    max_operating_differential_pressure: 500,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 2.0 Air (175)',
    outer_diameter: 4.75,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.3,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2498,
    max_operating_differential_pressure: 350,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 2.2 T1 (250)',
    outer_diameter: 4.75,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 2327,
    max_operating_differential_pressure: 550,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 2.2 T1 (175)',
    outer_diameter: 4.75,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 1628,
    max_operating_differential_pressure: 385,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 2.2 T2 (250)',
    outer_diameter: 4.75,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 2316,
    max_operating_differential_pressure: 550,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 2.2 T2 (175)',
    outer_diameter: 4.75,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 1619,
    max_operating_differential_pressure: 385,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 2.2 Slow (175)',
    outer_diameter: 4.75,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.31,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 2729,
    max_operating_differential_pressure: 385,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 2.2 Slow (250)',
    outer_diameter: 4.75,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.31,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 3902,
    max_operating_differential_pressure: 550,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 2.6 (175)',
    outer_diameter: 4.75,
    stages: 2.6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.26,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4072,
    max_operating_differential_pressure: 455,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 2.6 (250)',
    outer_diameter: 4.75,
    stages: 2.6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.26,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5818,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 2.9 (175)',
    outer_diameter: 4.75,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.3,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3866,
    max_operating_differential_pressure: 508,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 2.9 (250)',
    outer_diameter: 4.75,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.3,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 5523,
    max_operating_differential_pressure: 725,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 3.7 (175)',
    outer_diameter: 4.75,
    stages: 3.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.35,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 4856,
    max_operating_differential_pressure: 648,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 3.7 (250)',
    outer_diameter: 4.75,
    stages: 3.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.35,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 6894,
    max_operating_differential_pressure: 925,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 3.8 T1 (175)',
    outer_diameter: 4.75,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 2810,
    max_operating_differential_pressure: 665,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 3.8 T1 (250)',
    outer_diameter: 4.75,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 4018,
    max_operating_differential_pressure: 950,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 3.8 T2 (250)',
    outer_diameter: 4.75,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 4000,
    max_operating_differential_pressure: 950,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 3.8 T2 (175)',
    outer_diameter: 4.75,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 2810,
    max_operating_differential_pressure: 665,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 3.9 T1 (175)',
    outer_diameter: 4.75,
    stages: 3.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 2866,
    max_operating_differential_pressure: 683,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 3.9 T1 (250)',
    outer_diameter: 4.75,
    stages: 3.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 4124,
    max_operating_differential_pressure: 975,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 5.0 (250)',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.63,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4565,
    max_operating_differential_pressure: 1250,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 5.0 (175)',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.63,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 3193,
    max_operating_differential_pressure: 875,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 6.4 (175)',
    outer_diameter: 4.75,
    stages: 6.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.63,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4088,
    max_operating_differential_pressure: 1120,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '4 3/4 7:8 6.4 (250)',
    outer_diameter: 4.75,
    stages: 6.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.63,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5840,
    max_operating_differential_pressure: 1600,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 5:6 6.0 (175)',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.85,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 3214,
    max_operating_differential_pressure: 1050,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 5:6 6.0 (250)',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.85,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 4596,
    max_operating_differential_pressure: 1500,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 2.0 Air (250)',
    outer_diameter: 5,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.3,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 3751,
    max_operating_differential_pressure: 500,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 2.0 Air (175)',
    outer_diameter: 5,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.3,
    min_standard_flowrate: 100,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 2498,
    max_operating_differential_pressure: 350,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 2.2 T1 (175)',
    outer_diameter: 5,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 1628,
    max_operating_differential_pressure: 385,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 2.2 T1 (250)',
    outer_diameter: 5,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 2327,
    max_operating_differential_pressure: 550,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 2.2 T2 (175)',
    outer_diameter: 5,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 1619,
    max_operating_differential_pressure: 385,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 2.2 T2 (250)',
    outer_diameter: 5,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 2316,
    max_operating_differential_pressure: 550,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 2.2 Slow (250)',
    outer_diameter: 5,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.31,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 3902,
    max_operating_differential_pressure: 550,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 2.2 Slow (175)',
    outer_diameter: 5,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.31,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 2729,
    max_operating_differential_pressure: 385,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 2.6 (250)',
    outer_diameter: 5,
    stages: 2.6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.26,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5818,
    max_operating_differential_pressure: 650,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 2.6 (175)',
    outer_diameter: 5,
    stages: 2.6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.26,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4072,
    max_operating_differential_pressure: 455,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 3.7 (175)',
    outer_diameter: 5,
    stages: 3.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.35,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 4856,
    max_operating_differential_pressure: 648,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 3.7 (250)',
    outer_diameter: 5,
    stages: 3.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.35,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 6894,
    max_operating_differential_pressure: 925,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 3.8 T1 (175)',
    outer_diameter: 5,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 2810,
    max_operating_differential_pressure: 665,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 3.8 T1 (250)',
    outer_diameter: 5,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 4018,
    max_operating_differential_pressure: 950,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 3.8 T2 (250)',
    outer_diameter: 5,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 4000,
    max_operating_differential_pressure: 950,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 3.8 T2 (175)',
    outer_diameter: 5,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 2810,
    max_operating_differential_pressure: 665,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 3.9 (250)',
    outer_diameter: 5,
    stages: 3.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 4124,
    max_operating_differential_pressure: 975,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 3.9 (175)',
    outer_diameter: 5,
    stages: 3.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.51,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 2868,
    max_operating_differential_pressure: 683,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 5.0 (250)',
    outer_diameter: 5,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.63,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4566,
    max_operating_differential_pressure: 1250,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 5.0 (175)',
    outer_diameter: 5,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.63,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 3193,
    max_operating_differential_pressure: 875,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 6.4 (175)',
    outer_diameter: 5,
    stages: 6.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.63,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4088,
    max_operating_differential_pressure: 1120,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 (4 3/4) 7:8 6.4 (250)',
    outer_diameter: 5,
    stages: 6.4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.63,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5840,
    max_operating_differential_pressure: 1600,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 6:7 6.0 (250)',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.82,
    min_standard_flowrate: 150,
    max_standard_flowrate: 360,
    torque_at_max_operating_differential_pressure: 4650,
    max_operating_differential_pressure: 1500,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 6:7 6.0 (175)',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.82,
    min_standard_flowrate: 150,
    max_standard_flowrate: 360,
    torque_at_max_operating_differential_pressure: 3255,
    max_operating_differential_pressure: 1050,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 6:7 7.0 (175)',
    outer_diameter: 5,
    stages: 7,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.82,
    min_standard_flowrate: 150,
    max_standard_flowrate: 360,
    torque_at_max_operating_differential_pressure: 3798,
    max_operating_differential_pressure: 1225,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 6:7 7.0 (250)',
    outer_diameter: 5,
    stages: 7,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.82,
    min_standard_flowrate: 150,
    max_standard_flowrate: 360,
    torque_at_max_operating_differential_pressure: 5425,
    max_operating_differential_pressure: 1750,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 6:7 8.0 (175)',
    outer_diameter: 5,
    stages: 8,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.82,
    min_standard_flowrate: 150,
    max_standard_flowrate: 360,
    torque_at_max_operating_differential_pressure: 4340,
    max_operating_differential_pressure: 1400,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 6:7 8.0 (250)',
    outer_diameter: 5,
    stages: 8,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.82,
    min_standard_flowrate: 150,
    max_standard_flowrate: 360,
    torque_at_max_operating_differential_pressure: 6200,
    max_operating_differential_pressure: 2000,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 6:7 9.6 (175)',
    outer_diameter: 5,
    stages: 9.6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.81,
    min_standard_flowrate: 150,
    max_standard_flowrate: 360,
    torque_at_max_operating_differential_pressure: 5098,
    max_operating_differential_pressure: 1680,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 6:7 9.6 (250)',
    outer_diameter: 5,
    stages: 9.6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.81,
    min_standard_flowrate: 150,
    max_standard_flowrate: 360,
    torque_at_max_operating_differential_pressure: 7283,
    max_operating_differential_pressure: 2400,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 8:9 6.0 (250)',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 8,
    number_stator_lobes: 9,
    rpg: 0.51,
    min_standard_flowrate: 200,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 7338,
    max_operating_differential_pressure: 1500,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 8:9 6.0 (175)',
    outer_diameter: 5,
    stages: 6,
    number_rotor_lobes: 8,
    number_stator_lobes: 9,
    rpg: 0.51,
    min_standard_flowrate: 200,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 5137,
    max_operating_differential_pressure: 1050,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 9:10 2.1 (175)',
    outer_diameter: 5,
    stages: 2.1,
    number_rotor_lobes: 9,
    number_stator_lobes: 10,
    rpg: 0.17,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5322,
    max_operating_differential_pressure: 362,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '5 9:10 2.1 (250)',
    outer_diameter: 5,
    stages: 2.1,
    number_rotor_lobes: 9,
    number_stator_lobes: 10,
    rpg: 0.17,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 7610,
    max_operating_differential_pressure: 525,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 4:5 7.5 (250)',
    outer_diameter: 6.25,
    stages: 7.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.64,
    min_standard_flowrate: 200,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 7223,
    max_operating_differential_pressure: 1875,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 4:5 7.5 (175)',
    outer_diameter: 6.25,
    stages: 7.5,
    number_rotor_lobes: 4,
    number_stator_lobes: 5,
    rpg: 0.64,
    min_standard_flowrate: 200,
    max_standard_flowrate: 400,
    torque_at_max_operating_differential_pressure: 5055,
    max_operating_differential_pressure: 1313,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 6:7 5.0 (250)',
    outer_diameter: 6.25,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.34,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 9512,
    max_operating_differential_pressure: 1250,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 6:7 5.0 (175)',
    outer_diameter: 6.25,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.34,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 6652,
    max_operating_differential_pressure: 875,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 7:8 2.8 (250)',
    outer_diameter: 6.25,
    stages: 2.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.32,
    min_standard_flowrate: 300,
    max_standard_flowrate: 575,
    torque_at_max_operating_differential_pressure: 5661,
    max_operating_differential_pressure: 700,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 7:8 2.8 (175)',
    outer_diameter: 6.25,
    stages: 2.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.32,
    min_standard_flowrate: 300,
    max_standard_flowrate: 575,
    torque_at_max_operating_differential_pressure: 3958,
    max_operating_differential_pressure: 490,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 7:8 2.9 (250)',
    outer_diameter: 6.25,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 200,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10672,
    max_operating_differential_pressure: 725,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 7:8 2.9 (175)',
    outer_diameter: 6.25,
    stages: 2.9,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 200,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10144,
    max_operating_differential_pressure: 508,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 7:8 3.0 Slow (175)',
    outer_diameter: 6.25,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.2,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 6531,
    max_operating_differential_pressure: 525,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 7:8 3.0 Slow (250)',
    outer_diameter: 6.25,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.2,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9143,
    max_operating_differential_pressure: 735,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 7:8 3.3 (250)',
    outer_diameter: 6.25,
    stages: 3.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.15,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 12788,
    max_operating_differential_pressure: 825,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 7:8 3.3 (175)',
    outer_diameter: 6.25,
    stages: 3.3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.15,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 8993,
    max_operating_differential_pressure: 578,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 7:8 4.8 (250)',
    outer_diameter: 6.25,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.32,
    min_standard_flowrate: 300,
    max_standard_flowrate: 575,
    torque_at_max_operating_differential_pressure: 9738,
    max_operating_differential_pressure: 1200,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 7:8 4.8 (175)',
    outer_diameter: 6.25,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.32,
    min_standard_flowrate: 300,
    max_standard_flowrate: 575,
    torque_at_max_operating_differential_pressure: 6810,
    max_operating_differential_pressure: 840,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 7:8 6.0 (175)',
    outer_diameter: 6.25,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.36,
    min_standard_flowrate: 250,
    max_standard_flowrate: 550,
    torque_at_max_operating_differential_pressure: 7208,
    max_operating_differential_pressure: 1050,
  },
  {
    family: 'pdm',
    make: 'Weatherford',
    model: '6 1/4 7:8 6.0 (250)',
    outer_diameter: 6.25,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.36,
    min_standard_flowrate: 250,
    max_standard_flowrate: 550,
    torque_at_max_operating_differential_pressure: 10298,
    max_operating_differential_pressure: 1500,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 2 stg. Air',
    outer_diameter: 2.875,
    stages: 2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 2.154,
    min_standard_flowrate: 70,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 360,
    max_operating_differential_pressure: 300,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 3 stg.',
    outer_diameter: 2.875,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 2.7,
    min_standard_flowrate: 50,
    max_standard_flowrate: 100,
    torque_at_max_operating_differential_pressure: 440,
    max_operating_differential_pressure: 450,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 3.7 stg.',
    outer_diameter: 2.875,
    stages: 3.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 2.3,
    min_standard_flowrate: 60,
    max_standard_flowrate: 130,
    torque_at_max_operating_differential_pressure: 733,
    max_operating_differential_pressure: 648,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 3.8 stg.',
    outer_diameter: 3.5,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 1.57,
    min_standard_flowrate: 75,
    max_standard_flowrate: 150,
    torque_at_max_operating_differential_pressure: 1103,
    max_operating_differential_pressure: 665,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '5/6 ml 6 stg.',
    outer_diameter: 4.75,
    stages: 6,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.85,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 3214,
    max_operating_differential_pressure: 1050,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '5/6 ml 8.3 stg',
    outer_diameter: 4.75,
    stages: 8,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 1.04,
    min_standard_flowrate: 125,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 6420,
    max_operating_differential_pressure: 2490,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '6/7 ml 8.0 stg',
    outer_diameter: 4.75,
    stages: 8,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.807,
    min_standard_flowrate: 150,
    max_standard_flowrate: 350,
    torque_at_max_operating_differential_pressure: 5720,
    max_operating_differential_pressure: 1800,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 2.2 stg Slo',
    outer_diameter: 4.75,
    stages: 2.2,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.3,
    min_standard_flowrate: 100,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 3900,
    max_operating_differential_pressure: 550,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 2.6 stg',
    outer_diameter: 4.75,
    stages: 2.6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.26,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5250,
    max_operating_differential_pressure: 590,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 3.7 stg',
    outer_diameter: 4.75,
    stages: 3.7,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.356,
    min_standard_flowrate: 100,
    max_standard_flowrate: 275,
    torque_at_max_operating_differential_pressure: 5710,
    max_operating_differential_pressure: 840,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 3.8 stg',
    outer_diameter: 4.75,
    stages: 3.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.52,
    min_standard_flowrate: 150,
    max_standard_flowrate: 250,
    torque_at_max_operating_differential_pressure: 4450,
    max_operating_differential_pressure: 860,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 5 stg',
    outer_diameter: 4.75,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.63,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 4565,
    max_operating_differential_pressure: 1250,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '9/10 2.1 stg',
    outer_diameter: 4.75,
    stages: 2.1,
    number_rotor_lobes: 9,
    number_stator_lobes: 10,
    rpg: 0.17,
    min_standard_flowrate: 150,
    max_standard_flowrate: 300,
    torque_at_max_operating_differential_pressure: 5322,
    max_operating_differential_pressure: 362,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '4/5 ml 7 stg',
    outer_diameter: 6.5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.497,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9090,
    max_operating_differential_pressure: 1580,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '6/7 ml 5 stg',
    outer_diameter: 6.5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.29,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10400,
    max_operating_differential_pressure: 1250,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 2.1 stg',
    outer_diameter: 6.5,
    stages: 2.1,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.11,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 9645,
    max_operating_differential_pressure: 525,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 3 stg. Slo',
    outer_diameter: 6.5,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.15,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 12780,
    max_operating_differential_pressure: 750,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 4 stg',
    outer_diameter: 6.5,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.35,
    min_standard_flowrate: 200,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 7400,
    max_operating_differential_pressure: 1000,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 4.8 stg',
    outer_diameter: 6.5,
    stages: 4.8,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.32,
    min_standard_flowrate: 200,
    max_standard_flowrate: 500,
    torque_at_max_operating_differential_pressure: 9738,
    max_operating_differential_pressure: 1200,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 5 stg',
    outer_diameter: 6.5,
    stages: 5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.287,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 10460,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 6 stg',
    outer_diameter: 6.5,
    stages: 6,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.26,
    min_standard_flowrate: 300,
    max_standard_flowrate: 600,
    torque_at_max_operating_differential_pressure: 13600,
    max_operating_differential_pressure: 1500,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '9/10 3.5 stg.',
    outer_diameter: 6.5,
    stages: 3.5,
    number_rotor_lobes: 9,
    number_stator_lobes: 10,
    rpg: 0.15,
    min_standard_flowrate: 350,
    max_standard_flowrate: 625,
    torque_at_max_operating_differential_pressure: 10752,
    max_operating_differential_pressure: 619,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '6/7 ml 6 stg.',
    outer_diameter: 8,
    stages: 6,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.263,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 10427,
    max_operating_differential_pressure: 1050,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 2.5 stg. Slow',
    outer_diameter: 7.75,
    stages: 2.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.07,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 12816,
    max_operating_differential_pressure: 438,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 3 stg.',
    outer_diameter: 7.75,
    stages: 3,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.07,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 18314,
    max_operating_differential_pressure: 625,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 4 stg.',
    outer_diameter: 7.75,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.17,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 7550,
    max_operating_differential_pressure: 525,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 2.5 stg. Slo',
    outer_diameter: 7.75,
    stages: 2.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.16,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 11469,
    max_operating_differential_pressure: 700,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 4 stg',
    outer_diameter: 7.75,
    stages: 4,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.066,
    min_standard_flowrate: 400,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 14940,
    max_operating_differential_pressure: 900,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '8/9 ml 6 stg.',
    outer_diameter: 7.75,
    stages: 6,
    number_rotor_lobes: 8,
    number_stator_lobes: 9,
    rpg: 0.22,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 12548,
    max_operating_differential_pressure: 1050,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '5/6 ml 3 stg.',
    outer_diameter: 9.5,
    stages: 3,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.112,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 10685,
    max_operating_differential_pressure: 450,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '5/6 ml 4 stg.',
    outer_diameter: 9.5,
    stages: 4,
    number_rotor_lobes: 5,
    number_stator_lobes: 6,
    rpg: 0.11,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 16792,
    max_operating_differential_pressure: 700,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '5/6 5 ml stg',
    outer_diameter: 9.5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.14,
    min_standard_flowrate: 700,
    max_standard_flowrate: 1300,
    torque_at_max_operating_differential_pressure: 24170,
    max_operating_differential_pressure: 1130,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '6/7 ml 5 stg.',
    outer_diameter: 9.5,
    stages: 5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.12,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 18449,
    max_operating_differential_pressure: 875,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '7/8 ml 2.5 stg. Slow',
    outer_diameter: 9.5,
    stages: 2.5,
    number_rotor_lobes: 7,
    number_stator_lobes: 8,
    rpg: 0.07,
    min_standard_flowrate: 300,
    max_standard_flowrate: 900,
    torque_at_max_operating_differential_pressure: 12816,
    max_operating_differential_pressure: 438,
  },
  {
    family: 'pdm',
    make: 'Wenzel',
    model: '6/7 ml 3.5 stg. ERT',
    outer_diameter: 11.25,
    stages: 3.5,
    number_rotor_lobes: 6,
    number_stator_lobes: 7,
    rpg: 0.107,
    min_standard_flowrate: 600,
    max_standard_flowrate: 1200,
    torque_at_max_operating_differential_pressure: 32275,
    max_operating_differential_pressure: 1300,
  },
];
